webpackJsonp([41],{

/***/ "+2LS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+S+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "+UQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["HorizontalBar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "+Uuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__ = __webpack_require__("b6wd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fad54f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__ = __webpack_require__("CrRG");
function injectStyle (ssrContext) {
  __webpack_require__("2BJM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fad54f96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/7ZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__ = __webpack_require__("x2GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89518b96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__ = __webpack_require__("mLl1");
function injectStyle (ssrContext) {
  __webpack_require__("4BNY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticScrollbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89518b96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticScrollbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/LRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("vE+0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_987d0640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__ = __webpack_require__("ewoT");
function injectStyle (ssrContext) {
  __webpack_require__("nrVG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_987d0640_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSimpleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/tKm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal","duration":_vm.duration}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.clickMask($event)}}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalClass},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"modal-title"},[_vm._t("title")],2),_vm._v(" "),_c('a',{staticClass:"close-btn",on:{"click":_vm.cancel}},[_c('i',{staticClass:"fa fa-times-circle fa-stack-2x"})])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{class:_vm.okClass,attrs:{"type":"button"},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))]),_vm._v(" "),_c('button',{class:_vm.cancelClass,attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "01TB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0GMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("kT3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7c276e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__ = __webpack_require__("ddFr");
function injectStyle (ssrContext) {
  __webpack_require__("vuw1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e7c276e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7c276e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0xfL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "263+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2BJM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2EBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2wlW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3IyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-multi-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: Array,
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'multiselect'
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    toggleSelection: function toggleSelection(option) {
      var newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
      this.updateDisplayValue(newVal);
      this.$emit('input', newVal);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.value.includes(option);
    },
    selectOption: function selectOption(option) {
      return this.value.concat(option);
    },
    deselectOption: function deselectOption(option) {
      return this.value.filter(function (item) {
        return item !== option;
      });
    },
    updateDisplayValue: function updateDisplayValue(newVal) {
      if (newVal.length > 2) {
        this.displayValue = newVal.length + ' of ' + this.options.length + ' chosen';
      } else {
        this.displayValue = newVal.join(', ');
      }
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "3XSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "41de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var HORIZONTAL_LAYOUT = 'horizontal';
    var VERTICAL_LAYOUT = 'vertical';
    var initialLayout = binding.value.layout;
    var breakpoint = binding.value.breakPoint;

    var wizardLayout = initialLayout;

    var handleResize = function handleResize() {
      var width = window.innerWidth;
      var layout = width <= breakpoint ? HORIZONTAL_LAYOUT : VERTICAL_LAYOUT;
      if (wizardLayout !== layout) {
        wizardLayout = layout;
        vnode.context.$emit('wizardLayoutChange', wizardLayout);
      }
    };

    if (initialLayout === VERTICAL_LAYOUT) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }
});

/***/ }),

/***/ "4BNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4jdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4u7H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5U32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar app-navbar navbar-toggleable-md"},[_c('div',{staticClass:"navbar-brand-container d-flex align-items-center justify-content-start"},[_c('a',{staticClass:"navbar-brand",on:{"click":_vm.moveToProject}},[_c('i',{staticClass:"i-keylogs"})])]),_vm._v(" "),_c('div',{staticClass:"row navbar-container"},[_c('div',{staticClass:"menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col"},[(_vm.sidebarOpened)?_c('a',{staticClass:"menu-icon i-menu-expanded",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebarClick(false)}}}):_c('a',{staticClass:"menu-icon i-menu-collapsed",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleSidebarClick(true)}}})]),_vm._v(" "),_c('div',{staticClass:"offset-lg-9"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"nav-link dropdown-toggle d-flex align-items-center justify-content",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.closeMenu($event)}}},[_c('span',{staticClass:"avatar-container"},[_c('img',{attrs:{"src":_vm.image,"title":_vm.user.name}})])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu last"},[_c('div',{staticClass:"dropdown-menu-content"},[_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('router-link',{staticClass:"plain-link white",attrs:{"to":"/profile"}},[_vm._v("Profile")])],1),_vm._v(" "),(_vm.user.mainuser)?_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('router-link',{staticClass:"plain-link white",attrs:{"to":"/subscription"}},[_vm._v("Subscription")])],1):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-item plain-link-item"},[_c('a',{staticClass:"plain-link",on:{"click":_vm.logout}},[_vm._v("Logout")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"},[_c('a',{staticClass:"tutorial-link",attrs:{"href":"https://keylogs.io/blog/tutorials","target":"blank","title":"Keylogs Tutorials"}},[_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-question fa-stack-1x"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-item plain-link-item mobile-only"},[_c('a',{staticClass:"plain-link white",attrs:{"href":"https://keylogs.io/blog/tutorials","target":"blank"}},[_vm._v("Tutorials")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6b69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-widget',

  props: ['headerText']
});

/***/ }),

/***/ "73vl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "74xX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__ = __webpack_require__("dRu4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ee75c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__ = __webpack_require__("OSud");
function injectStyle (ssrContext) {
  __webpack_require__("nRnU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProfileCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9ee75c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProfileCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "8/T/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__ = __webpack_require__("mpwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd2aeef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__ = __webpack_require__("co6K");
function injectStyle (ssrContext) {
  __webpack_require__("q8pK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dd2aeef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd2aeef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AKm5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bubble"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "Ah0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav hidden-lg-up"},[_c('router-link',{staticClass:"i-keylogs",attrs:{"to":{path: '/'}}})],1),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view')],1),_c('div',{staticClass:"auth-wallpaper col-6 hidden-md-down"},[_c('div',{staticClass:"oblique"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('router-link',{staticClass:"i-keylogs",attrs:{"to":{path: '/'}}})],1),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"claim"},[_vm._v("Better Search Console Insights")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B616":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal"},[(_vm.size != 'thick')?_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('width: ' + _vm.value + '%')},[(_vm.size == 'thick')?_c('span',{staticClass:"value",class:{hidden: _vm.animatedValue == _vm.min}},[_vm._v("\n        "+_vm._s(_vm.animatedValue + '%')+"\n      ")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_47baa4c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("XbZi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_47baa4c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BSUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"good-table",class:{'rtl': _vm.rtl}},[_c('div',{class:{'responsive': _vm.responsive}},[(_vm.title || _vm.$slots['table-actions'])?_c('div',{staticClass:"table-header clearfix"},[_c('h2',{staticClass:"table-title pull-left"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"actions pull-right"},[_vm._t("table-actions")],2)]):_vm._e(),_vm._v(" "),(_vm.paginate && _vm.paginateOnTop)?_c('vue-good-pagination',{attrs:{"perPage":_vm.perPage,"rtl":_vm.rtl,"total":_vm.processedRows.length,"nextText":_vm.nextText,"prevText":_vm.prevText,"rowsPerPageText":_vm.rowsPerPageText,"ofText":_vm.ofText,"allText":_vm.allText},on:{"page-changed":_vm.pageChanged,"per-page-changed":_vm.perPageChanged}}):_vm._e(),_vm._v(" "),_c('table',{ref:"table",class:_vm.styleClass},[_c('thead',[(_vm.globalSearch && _vm.externalSearchQuery == null)?_c('tr',[_c('td',{attrs:{"colspan":_vm.lineNumbers ? _vm.columns.length + 1: _vm.columns.length}},[_c('div',{staticClass:"global-search"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.globalSearchTerm),expression:"globalSearchTerm"}],staticClass:"form-control global-search-input",attrs:{"type":"text","placeholder":_vm.globalSearchPlaceholder},domProps:{"value":(_vm.globalSearchTerm)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchTable()},"input":function($event){if($event.target.composing){ return; }_vm.globalSearchTerm=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('tr',[(_vm.lineNumbers)?_c('th',{staticClass:"line-numbers"}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return (!column.hidden)?_c('th',{key:column.field,class:_vm.getHeaderClasses(column, index),style:({width: column.width ? column.width : 'auto'}),on:{"click":function($event){_vm.sort(index)}}},[_vm._t("table-column",[_c('span',[_vm._v(_vm._s(column.label))])],{column:column})],2):_vm._e()}),_vm._v(" "),_vm._t("thead-tr")],2),_vm._v(" "),(_vm.hasFilterRow)?_c('tr',[(_vm.lineNumbers)?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(column,index){return (!column.hidden)?_c('th',{key:column.field},[(column.filterable)?_c('div',{class:_vm.getHeaderClasses(column, index)},[(!column.filterDropdown)?_c('input',{attrs:{"type":"text","placeholder":_vm.getPlaceholder(column)},domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}}):_vm._e(),_vm._v(" "),(column.filterDropdown && typeof(column.filterOptions[0]) !== 'object')?_c('select',{domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.getPlaceholder(column)))]),_vm._v(" "),_vm._l((column.filterOptions),function(option){return _c('option',{key:option,domProps:{"value":option}},[_vm._v("\n                    "+_vm._s(option)+"\n                  ")])})],2):_vm._e(),_vm._v(" "),(column.filterDropdown && typeof(column.filterOptions[0]) === 'object')?_c('select',{domProps:{"value":_vm.columnFilters[column.field]},on:{"input":function($event){_vm.updateFilters(column, $event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.getPlaceholder(column)))]),_vm._v(" "),_vm._l((column.filterOptions),function(option){return _c('option',{key:option,domProps:{"value":option.value}},[_vm._v(_vm._s(option.text))])})],2):_vm._e()]):_vm._e()]):_vm._e()})],2):_vm._e()]),_vm._v(" "),_c('tbody',[_vm._l((_vm.paginated),function(row,index){return _c('tr',{key:index,class:_vm.getRowStyleClass(row),on:{"click":function($event){_vm.click(row, index)}}},[(_vm.lineNumbers)?_c('th',{staticClass:"line-numbers"},[_vm._v(_vm._s(_vm.getCurrentIndex(index)))]):_vm._e(),_vm._v(" "),_vm._t("table-row-before",null,{row:row,index:index}),_vm._v(" "),_vm._t("table-row",_vm._l((_vm.columns),function(column,i){return (!column.hidden && column.field)?_c('td',{key:column.field,class:_vm.getClasses(i, 'td')},[(!column.html)?_c('span',[_vm._v(_vm._s(_vm.collectFormatted(row, column)))]):_vm._e(),_vm._v(" "),(column.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.collect(row, column.field))}}):_vm._e()]):_vm._e()}),{row:row,formattedRow:_vm.formattedRow(row),index:index}),_vm._v(" "),_vm._t("table-row-after",null,{row:row,index:index})],2)}),_vm._v(" "),(_vm.processedRows.length === 0)?_c('tr',[_c('td',{attrs:{"colspan":_vm.columns.length}},[_vm._t("emptystate",[_c('div',{staticClass:"center-align text-disabled"},[_vm._v("\n                No data for table.\n              ")])])],2)]):_vm._e()],2)]),_vm._v(" "),(_vm.paginate && !_vm.paginateOnTop)?_c('vue-good-pagination',{attrs:{"perPage":_vm.perPage,"rtl":_vm.rtl,"total":_vm.processedRows.length,"nextText":_vm.nextText,"prevText":_vm.prevText,"rowsPerPageText":_vm.rowsPerPageText,"ofText":_vm.ofText,"allText":_vm.allText},on:{"page-changed":_vm.pageChanged,"per-page-changed":_vm.perPageChanged}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"global-search-icon"},[_c('div',{staticClass:"magnifying-glass"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bd06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('i',{staticClass:"ion ion-android-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-android-done step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-line"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CHUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  table: {
    tableClass: 'table table-striped',
    ascendingIcon: 'entypo entypo-up-dir',
    descendingIcon: 'entypo entypo-down-dir'
  },
  pagination: {
    wrapperClass: 'btn-group',
    activeClass: 'focus',
    disabledClass: 'disabled',
    pageClass: 'btn btn-primary hide-not-focused-btn',
    linkClass: 'btn btn-primary pagination-link-btn',
    icons: {
      first: 'fa fa-angle-double-left',
      prev: 'fa fa-angle-left',
      next: 'fa fa-angle-right',
      last: 'fa fa-angle-double-right'
    }
  }
});

/***/ }),

/***/ "CneO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__ = __webpack_require__("pr2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71529c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__ = __webpack_require__("B616");
function injectStyle (ssrContext) {
  __webpack_require__("Lip1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71529c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorizontalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CrRG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chart"},[(_vm.type === 'pie')?_c('pie-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'donut')?_c('donut-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'bubble')?_c('bubble-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'line')?_c('line-chart',{attrs:{"options":_vm.options,"chartData":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'horizontal-bar')?_c('horizontal-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e(),_vm._v(" "),(_vm.type === 'vertical-bar')?_c('vertical-bar-chart',{attrs:{"options":_vm.options,"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dmbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__ = __webpack_require__("6b69");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c169fe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__ = __webpack_require__("DrP2");
function injectStyle (ssrContext) {
  __webpack_require__("IB/C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c169fe1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DrP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:{'no-header': !_vm.headerText}},[(_vm.headerText)?_c('div',{staticClass:"widget-header"},[_vm._v(_vm._s(_vm.headerText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_EXPAND_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_SIDEBAR_FORCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HOVER_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TOGGLE_WITHOUT_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGOUT; });
var TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM';

var CLOSE_MENU = 'CLOSE_MENU';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
var TOGGLE_SIDEBAR_FORCE = 'TOGGLE_SIDEBAR_FORCE';

var HOVER_SIDEBAR = 'HOVER_SIDEBAR';

var TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION';

var SUBSCRIPTION = 'SUBSCRIPTION';

var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';

/***/ }),

/***/ "ECp3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[[_c('col',{class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields}},[_vm._v(_vm._s(_vm.noDataTemplate))])])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){_vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{class:['vuetable-th-'+field.name, field.titleClass,  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){_vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,index){return [_c('tr',{class:_vm.onRowClass(item, index),attrs:{"item-index":index,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){_vm.onRowDoubleClicked(item, $event)},"click":function($event){_vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(index))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){_vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":index,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{rowData:item,rowIndex:index,rowField:field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}}):_c('td',{class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){_vm.onCellClicked(item, field, $event)},"dblclick":function($event){_vm.onCellDoubleClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){_vm.onDetailRowClick(item, $event)}}},[_c('transition',{attrs:{"name":_vm.detailRowTransition}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":index}})],1)])],1):_vm._e()]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field){return [(field.visible)?_c('td',[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FEme":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group with-icon-left"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],attrs:{"id":"input-icon-left","name":"input-icon-left","required":""},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){_vm.doFilter()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-search icon-left input-icon search-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"input-icon-left"}},[_vm._v("Search")]),_c('i',{staticClass:"bar"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GB0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AuthLayout'
});

/***/ }),

/***/ "GI4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "GslS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__ = __webpack_require__("cfdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__ = __webpack_require__("+Uuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__ = __webpack_require__("oXux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__ = __webpack_require__("tZ2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__ = __webpack_require__("Q4Rp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__ = __webpack_require__("NG7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__ = __webpack_require__("IqWy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__ = __webpack_require__("74xX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__ = __webpack_require__("XznE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__ = __webpack_require__("/LRh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__ = __webpack_require__("anct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__ = __webpack_require__("rhzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__ = __webpack_require__("LtNJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__ = __webpack_require__("Dmbe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__ = __webpack_require__("8/T/");


















var VuesticComponentsPlugin = {
  install: function install(Vue, options) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_0_src_components_vuestic_components_vuestic_alert_VuesticAlert_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_1_src_components_vuestic_components_vuestic_chart_VuesticChart_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_2_src_components_vuestic_components_vuestic_chat_VuesticChat_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_3_src_components_vuestic_components_vuestic_datatable_VuesticDataTable_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_4_src_components_vuestic_components_vuestic_feed_VuesticFeed_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_5_src_components_vuestic_components_vuestic_modal_VuesticModal_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_6_src_components_vuestic_components_vuestic_multi_select_VuesticMultiSelect_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_7_src_components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_8_src_components_vuestic_components_vuestic_profile_card_VuesticProfileCard_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_progress_bar_VuesticProgressBar_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_10_src_components_vuestic_components_vuestic_scrollbar_VuesticScrollbar_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_11_src_components_vuestic_components_vuestic_simple_select_VuesticSimpleSelect_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_12_src_components_vuestic_components_vuestic_social_news_VuesticSocialNews_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_13_src_components_vuestic_components_vuestic_switch_VuesticSwitch_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_14_src_components_vuestic_components_vuestic_tabs_VuesticTabs_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_15_src_components_vuestic_components_vuestic_widget_VuesticWidget_vue__["default"]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"].name, __WEBPACK_IMPORTED_MODULE_16_src_components_vuestic_components_vuestic_wizard_VuesticWizard_vue__["default"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VuesticComponentsPlugin);

/***/ }),

/***/ "HXSn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IB/C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IbS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__ = __webpack_require__("iZBt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae0978c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__ = __webpack_require__("nP/+");
function injectStyle (ssrContext) {
  __webpack_require__("iQfA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ae0978c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemsPerPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae0978c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemsPerPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_menu__ = __webpack_require__("ZEli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__("WSTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filter__ = __webpack_require__("c0ch");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5__filter__["a" /* default */].create(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    menu: __WEBPACK_IMPORTED_MODULE_2__modules_menu__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "IqWy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__ = __webpack_require__("3IyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a859bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__ = __webpack_require__("pNRk");
function injectStyle (ssrContext) {
  __webpack_require__("v3tk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15a859bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "J47m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("bBbP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_810f4a52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("lYPE");
function injectStyle (ssrContext) {
  __webpack_require__("sAFs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-810f4a52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_810f4a52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K6l1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KE38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_esm__ = __webpack_require__("8wyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pagination_vue__ = __webpack_require__("J47m");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-good-table',
  components: {
    VueGoodPagination: __WEBPACK_IMPORTED_MODULE_6__Pagination_vue__["a" /* default */]
  },
  props: {
    styleClass: { default: 'table table-bordered' },
    title: '',
    columns: {},
    rows: {},
    onClick: {},
    perPage: {},
    sortable: { default: true },
    paginate: { default: false },
    paginateOnTop: { default: false },
    lineNumbers: { default: false },
    defaultSortBy: { default: null },
    responsive: { default: true },
    rtl: { default: false },
    rowStyleClass: { default: null, type: [Function, String] },

    globalSearch: { default: false },
    searchTrigger: { default: null },
    externalSearchQuery: { default: null },

    globalSearchPlaceholder: { default: 'Search Table' },

    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10,
      sortColumn: -1,
      sortType: 'asc',
      globalSearchTerm: '',
      columnFilters: {},
      filteredRows: [],
      timer: null,
      forceSearch: false,
      sortChanged: false
    };
  },

  methods: {
    pageChanged: function pageChanged(pagination) {
      this.currentPage = pagination.currentPage;
      this.$emit('pageChanged', { currentPage: this.currentPage, total: Math.floor(this.rows.length / this.currentPerPage) });
    },
    perPageChanged: function perPageChanged(pagination) {
      this.currentPerPage = pagination.currentPerPage;
    },
    sort: function sort(index) {
      if (!this.isSortableColumn(index)) return;
      if (this.sortColumn === index) {
        this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortType = 'asc';
        this.sortColumn = index;
      }
      this.sortChanged = true;
    },
    click: function click(row, index) {
      if (this.onClick) this.onClick(row, index);
    },
    searchTable: function searchTable() {
      if (this.searchTrigger == 'enter') {
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },
    collect: function collect(obj, field) {
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');
        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined') return undefined;else result = result[splitter[i]];
        }return result;
      }

      if (typeof field === 'function') return field(obj);else if (typeof field === 'string') return dig(obj, field);else return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      function formatDecimal(v) {
        return parseFloat(Math.round(v * 100) / 100).toFixed(2);
      }

      function formatPercent(v) {
        return parseFloat(v * 100).toFixed(2) + '%';
      }

      function formatDate(v) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["b" /* format */])(Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["d" /* parse */])(v, column.inputFormat, new Date()), column.outputFormat);
      }

      var value = this.collect(obj, column.field);

      if (value === undefined) return '';

      switch (column.type) {
        case 'decimal':
          return formatDecimal(value);
        case 'percentage':
          return formatPercent(value);
        case 'date':
          return formatDate(value);
        default:
          return value;
      }
    },
    formattedRow: function formattedRow(row) {
      var formattedRow = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var col = _step.value;

          if (col.field) {
            formattedRow[col.field] = this.collectFormatted(row, col);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formattedRow;
    },
    isSortableColumn: function isSortableColumn(index) {
      var sortable = this.columns[index].sortable;
      var isSortable = typeof sortable === 'boolean' ? sortable : this.sortable;
      return isSortable;
    },
    getHeaderClasses: function getHeaderClasses(column, index) {
      var isSortable = this.isSortableColumn(index);
      var classes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.getClasses(index, 'th'), {
        'sorting': isSortable,
        'sorting-desc': isSortable && this.sortColumn === index && this.sortType === 'desc',
        'sorting-asc': isSortable && this.sortColumn === index && this.sortType === 'asc'
      });
      return classes;
    },
    getClasses: function getClasses(index, element) {
      var _columns$index = this.columns[index],
          type = _columns$index.type,
          custom = _columns$index[element + 'Class'];

      var isRight = ['number', 'percentage', 'decimal', 'date'].includes(type);
      if (this.rtl) isRight = true;
      var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        'right-align': isRight,
        'left-align': !isRight
      }, custom, !!custom);
      return classes;
    },
    updateFilters: function updateFilters(column, value) {
      var _this = this;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.$set(_this.columnFilters, column.field, value);
      }, 400);
    },
    filterRows: function filterRows() {
      var _this2 = this;

      var computedRows = this.originalRows;

      if (this.hasFilterRow) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var col = _step2.value;

            if (col.filterable && this.columnFilters[col.field]) {
              computedRows = computedRows.filter(function (row) {

                if (col.filter) {
                  return col.filter(_this2.collect(row, col.field), _this2.columnFilters[col.field]);
                }

                switch (col.type) {
                  case 'number':
                  case 'percentage':
                  case 'decimal':
                    return _this2.collect(row, col.field) == _this2.columnFilters[col.field];
                  default:
                    return _this2.collect(row, col.field).toLowerCase().includes(_this2.columnFilters[col.field].toLowerCase());
                }
              });
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.filteredRows = computedRows;
    },
    getPlaceholder: function getPlaceholder(column) {
      var placeholder = column.placeholder || 'Filter ' + column.label;
      return placeholder;
    },
    getCurrentIndex: function getCurrentIndex(index) {
      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    getRowStyleClass: function getRowStyleClass(row) {
      var classes = '';
      this.onClick ? classes += 'clickable' : '';
      var rowStyleClasses = void 0;
      if (typeof this.rowStyleClass === 'function') {
        rowStyleClasses = this.rowStyleClass(row);
      } else {
        rowStyleClasses = this.rowStyleClass;
      }
      if (rowStyleClasses) {
        classes += ' ' + rowStyleClasses;
      }
      return classes;
    }
  },

  watch: {
    columnFilters: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    },
    rows: {
      handler: function handler(newObj) {
        this.filterRows();
      },
      deep: true
    }

  },

  computed: {
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.globalSearch && !!this.globalSearchTerm && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger != 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },
    hasFilterRow: function hasFilterRow() {
      if (!this.globalSearch) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.columns), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var col = _step3.value;

            if (col.filterable) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return false;
    },
    processedRows: function processedRows() {
      var _this3 = this;

      var computedRows = this.filteredRows;

      if (this.globalSearchAllowed) {
        var filteredRows = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.originalRows), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var row = _step4.value;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.columns), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var col = _step5.value;

                if (String(this.collectFormatted(row, col)).toLowerCase().search(this.searchTerm.toLowerCase()) > -1) {
                  filteredRows.push(row);
                  break;
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        computedRows = filteredRows;
      }

      if (this.sortColumn !== -1 && this.isSortableColumn(this.sortColumn) && (this.searchTrigger !== 'enter' || this.sortChanged)) {

        this.sortChanged = false;

        computedRows = computedRows.sort(function (x, y) {
          if (!_this3.columns[_this3.sortColumn]) return 0;

          var cook = function cook(d) {
            d = _this3.collect(d, _this3.columns[_this3.sortColumn].field);

            if (_this3.columns[_this3.sortColumn].type === 'date') {
              d = Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["d" /* parse */])(d + '', _this3.columns[_this3.sortColumn].inputFormat, new Date());
            } else if (typeof d === 'string') {
              d = d.toLowerCase();
              if (_this3.columns[_this3.sortColumn].type === 'number') d = d.indexOf('.') >= 0 ? parseFloat(d) : parseInt(d);
            }
            return d;
          };

          x = cook(x);
          y = cook(y);

          if (_this3.columns[_this3.sortColumn].type === 'date') {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["c" /* isValid */])(x)) {
              return -1 * (_this3.sortType === 'desc' ? -1 : 1);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["c" /* isValid */])(y)) {
              return _this3.sortType === 'desc' ? -1 : 1;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_5_date_fns_esm__["a" /* compareAsc */])(x, y) * (_this3.sortType === 'desc' ? -1 : 1);
          }

          return (x < y ? -1 : x > y ? 1 : 0) * (_this3.sortType === 'desc' ? -1 : 1);
        });
      }

      if (this.searchTrigger === 'enter') {
        this.filteredRows = computedRows;
      }

      return computedRows;
    },
    paginated: function paginated() {
      var paginatedRows = this.processedRows;

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage;

        if (pageStart >= this.processedRows.length || this.currentPerPage === -1) {
          this.currentPage = 1;
          pageStart = 0;
        }

        var pageEnd = paginatedRows.length + 1;

        if (this.currentPerPage !== -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      }
      return paginatedRows;
    },
    originalRows: function originalRows() {
      var rows = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.rows));

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(rows.entries()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _ref = _step6.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var index = _ref2[0];
          var row = _ref2[1];

          row.originalIndex = index;
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return rows;
    }
  },

  mounted: function mounted() {
    this.filteredRows = this.originalRows;

    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }

    if (this.defaultSortBy) {
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.columns.entries()), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var _ref3 = _step7.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var index = _ref4[0];
          var col = _ref4[1];

          if (col.field === this.defaultSortBy.field) {
            this.sortColumn = index;
            this.sortType = this.defaultSortBy.type || 'asc';
            this.sortChanged = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "KGMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__ = __webpack_require__("CneO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__ = __webpack_require__("axM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__ = __webpack_require__("pqzW");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-progress-bar',
  components: {
    HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__progress_types_HorizontalProgressBar_vue__["default"],
    VerticalBar: __WEBPACK_IMPORTED_MODULE_2__progress_types_VerticalProgressBar_vue__["default"],
    CircleBar: __WEBPACK_IMPORTED_MODULE_3__progress_types_CircleProgressBar_vue__["default"]
  },
  props: {
    type: {
      type: String,
      default: 'horizontal'
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: 'basic'
    },
    colorName: {
      type: String,
      default: 'primary'
    },
    startColorName: {
      type: String,
      default: 'lighterGray'
    },
    backgroundColorName: {
      type: String,
      default: 'white'
    }
  },
  watch: {
    value: function value() {
      this.animateValue();
    }
  },
  methods: {
    animateValue: function animateValue() {
      var _this = this;

      console.log(this.value);
      var startValue = this.value;
      var valueMsecs = this.valueAnimationInterval / this.max;
      var delta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(this.value - this.animatedValue);
      var valueInterval = setInterval(function () {
        if (!_this.$refs.bar) {
          clearInterval(valueInterval);
          return;
        }
        if (startValue !== _this.value || _this.animatedValue === _this.value) {
          clearInterval(valueInterval);
          if (_this.value === _this.max) {
            _this.isActive = false;
          }
        } else {
          _this.animatedValue += delta;
        }
      }, valueMsecs);
    }
  },
  data: function data() {
    return {
      value: 0,
      valueAnimationInterval: 2000,
      animatedValue: 0,
      isActive: false,
      startColor: this.$store.state.app.config.palette[this.startColorName],
      color: this.$store.state.app.config.palette[this.colorName],
      backgroundColor: this.$store.state.app.config.palette[this.backgroundColorName]
    };
  }
});

/***/ }),

/***/ "LDXv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LJXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"beforeEnter":_vm.beforeEnter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave,"afterLeave":_vm.afterLeave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lip1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LtNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__ = __webpack_require__("MhID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fad91356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__ = __webpack_require__("YKch");
function injectStyle (ssrContext) {
  __webpack_require__("wzle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fad91356_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PO8x");
function injectStyle (ssrContext) {
  __webpack_require__("2wlW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MEVT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__ = __webpack_require__("QI9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__ = __webpack_require__("jEUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__ = __webpack_require__("noQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'layout',
  components: {
    VuesticPreLoader: __WEBPACK_IMPORTED_MODULE_5__vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"],
    Navbar: __WEBPACK_IMPORTED_MODULE_2__navbar_Navbar__["default"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_3__sidebar_Sidebar__["default"]
  },
  directives: {
    resize: __WEBPACK_IMPORTED_MODULE_4_directives_ResizeHandler__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['sidebarOpened', 'toggleWithoutAnimation', 'isLoading']), {
    classObject: function classObject() {
      return {
        'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
        'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
      };
    }
  })
});

/***/ }),

/***/ "MhID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-tabs',
  props: ['names'],
  computed: {
    underscoreClass: function underscoreClass() {
      return 'underscore-' + this.names.length + '-' + this.names.indexOf(this.currentActive);
    }
  },
  methods: {
    setActive: function setActive(name) {
      this.currentActive = name;
    }
  },
  data: function data() {
    return {
      currentActive: this.names[0]
    };
  }
});

/***/ }),

/***/ "NG7M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__ = __webpack_require__("dtfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29177095_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__ = __webpack_require__("/tKm");
function injectStyle (ssrContext) {
  __webpack_require__("+2LS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29177095"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29177095_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("RxS7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("4TSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_table_component__ = __webpack_require__("sch3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_table_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_table_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_components_plugin__ = __webpack_require__("GslS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lodash__ = __webpack_require__("NETs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_good_table__ = __webpack_require__("rKEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__ = __webpack_require__("h/Ox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_moment__);





















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('table-component', __WEBPACK_IMPORTED_MODULE_4_vue_table_component__["TableComponent"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('table-column', __WEBPACK_IMPORTED_MODULE_4_vue_table_component__["TableColumn"]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_13_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_src_components_vuestic_components_vuestic_components_plugin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_10_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_gtm___default.a, {
  appName: 'Keylogs',
  appVersion: '1.0',
  debug: false,
  vueRouter: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */] });

__WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.baseURL = 'http://localhost:3245/api/';
if (true) __WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.baseURL = 'https://app.keylogs.io/api/';
if (false) axios.defaults.baseURL = 'https://keylogs.staging.webmarken.com/api/';

__WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.headers.get['Auth'] = localStorage.getItem('token');
__WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.headers.post['Auth'] = localStorage.getItem('token');
__WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.headers.delete['Auth'] = localStorage.getItem('token');
__WEBPACK_IMPORTED_MODULE_13_axios___default.a.defaults.headers.put['Auth'] = localStorage.getItem('token');

__WEBPACK_IMPORTED_MODULE_13_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var originalRequest = error.config;
  console.log(error);

  if (error.response.status === 401 && typeof originalRequest.headers.Auth === 'string') {
    console.log('user unauthorized - log out');
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('logout');
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vee_validate___default.a, { fieldsBagName: 'formFields' });

Object(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */]);

var mediaHandler = function mediaHandler() {
  if (window.matchMedia(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].getters.config.windowMatchSizeLg).matches) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('toggleSidebar', false);
  } else {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('toggleSidebar', false);
  }
};

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setLoading', true);

  if (to.name === 'Login') next();else {
    try {
      var subscription = JSON.parse(localStorage.getItem('subscription'));
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setSubscription', subscription || false);
    } catch (e) {
      console.log(e);
      __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('setSubscription', false);
    }

    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].dispatch('isLoggedIn').then(function (response) {
      if (response) {
        next();
      } else {
        next({ path: '/login' });
      }
    }, function (error) {
      console.log(error);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].afterEach(function (to, from) {
  mediaHandler();
  __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit('setLoading', false);
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "NS1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var duration = binding.value.duration || 500;
    var isAnimated = binding.value.animate;

    var observer = new MutationObserver(scrollToBottom);
    var config = { childList: true };
    observer.observe(el, config);

    function animateScroll(duration) {
      var start = el.scrollTop;
      var end = el.scrollHeight;
      var change = end - start;
      var increment = 20;

      function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
          return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
      }

      function animate(elapsedTime) {
        elapsedTime += increment;
        var position = easeInOut(elapsedTime, start, change, duration);
        el.scrollTop = position;

        if (elapsedTime < duration) {
          setTimeout(function () {
            animate(elapsedTime);
          }, increment);
        }
      }

      animate(0);
    }

    function scrollToBottom() {
      if (isAnimated) {
        animateScroll(duration);
      } else {
        el.scrollTop = el.scrollHeight;
      }
    }
  }
});

/***/ }),

/***/ "NoHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Pie"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "O3lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__("mUJ2")("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),

/***/ "OPFe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__ = __webpack_require__("WHJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_16231e34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__ = __webpack_require__("LJXN");
function injectStyle (ssrContext) {
  __webpack_require__("UemN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16231e34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Expanding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_16231e34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Expanding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OR0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    var ddToggle = el.querySelector('.dropdown-toggle');
    var ddMenu = el.querySelector('.dropdown-menu');
    var closeOnMenuClick = binding.modifiers.closeOnMenuClick;

    ddToggle.addEventListener('click', function (evt) {
      evt.preventDefault();
      var isShown = el.classList.contains('show');
      setTimeout(function () {
        return el.classList.toggle('show', !isShown);
      });
    });

    ddToggle.addEventListener('mouseenter', function (evt) {
      evt.preventDefault();
      var isShown = el.classList.contains('show');
      setTimeout(function () {
        return el.classList.toggle('show', !isShown);
      });
    });

    ddMenu.addEventListener('mouseleave', function (evt) {
      el.classList.remove('show');
    });

    window.addEventListener('click', function () {
      el.classList.remove('show');
    });

    ddMenu.addEventListener('click', function (evt) {
      if (!closeOnMenuClick) {
        evt.stopPropagation();
      } else {
        el.classList.remove('show');
      }
    });
  }
});

/***/ }),

/***/ "OSud":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-profile-card d-flex flex-column align-items-center"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.photoSource}})]),_vm._v(" "),_c('h5',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',{staticClass:"location"},[_c('span',{staticClass:"icon glyphicon glyphicon-map-marker"}),_vm._v(" "+_vm._s(_vm.location))]),_vm._v(" "),_c('div',{staticClass:"social"},[(_vm.social.facebook)?_c('a',{staticClass:"icon brandico brandico-facebook-rect",attrs:{"href":'http://' + _vm.social.facebook,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.instagram)?_c('a',{staticClass:"icon brandico brandico-instagram",attrs:{"href":'http://' + _vm.social.instagram,"target":"_blank"}}):_vm._e(),_vm._v(" "),(_vm.social.twitter)?_c('a',{staticClass:"icon brandico brandico-twitter",attrs:{"href":'http://' + _vm.social.twitter,"target":"_blank"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oc0A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PO8x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.isAuth)?_c('auth-layout'):_c('layout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q4Rp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__ = __webpack_require__("gvyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688eead6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__ = __webpack_require__("Uis9");
function injectStyle (ssrContext) {
  __webpack_require__("HXSn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticFeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688eead6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticFeed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QI9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("oK+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b5a50c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("5U32");
function injectStyle (ssrContext) {
  __webpack_require__("3XSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69b5a50c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QzAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RMJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},[_c('ul',{staticClass:"sidebar-menu"},_vm._l((_vm.myMenu),function(item,index){return _c('li',[(item.path)?_c('router-link',{staticClass:"sidebar-link",attrs:{"to":item.path},on:{"click":function($event){_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("            "+_vm._s(item.meta.title))]):_c('a',{staticClass:"sidebar-link",class:{expanded: item.meta.expanded},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenuItem(item)}}},[_c('i',{staticClass:"sidebar-menu-item-icon",class:item.meta.iconClass}),_vm._v("            "+_vm._s(item.meta.title)),_c('i',{staticClass:"expand-icon fa fa-angle-down"})]),_c('expanding',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(item.meta.expanded),expression:"item.meta.expanded"}],staticClass:"sidebar-submenu in"},_vm._l((item.children),function(childItem){return _c('li',{class:{divider: childItem.meta.divider}},[_c('router-link',{staticClass:"sidebar-link sidebar-submenu-link",attrs:{"to":childItem.path}},[_c('i',{staticClass:"submenu-icon",class:_vm.computedClass(childItem.meta)}),_vm._v(" "+_vm._s(childItem.meta.title))])],1)}))])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TkXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-social-news"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center text-w-btn"},[_c('span',{staticClass:"text"},[_vm._v("That what users have posted about your business.")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('button',{staticClass:"btn btn-micro btn-primary"},[_vm._v("VIEW")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-around photos"},_vm._l((_vm.news),function(pieceOfNews){return _c('div',{staticClass:"photo",style:(("background: url(" + (pieceOfNews.photoURL) + ")"))})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TqWO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UX9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"vuestic-progress-bar"},[(_vm.type == 'horizontal')?_c('horizontal-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'vertical')?_c('vertical-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"size":_vm.size,"color":_vm.color,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e(),_vm._v(" "),(_vm.type == 'circle')?_c('circle-bar',{ref:"bar",attrs:{"min":_vm.min,"max":_vm.max,"value":_vm.value,"color":_vm.color,"background-color":_vm.backgroundColor,"start-color":_vm.startColor,"isActive":_vm.isActive,"animatedValue":_vm.animatedValue}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UemN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uis9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-feed"},[(_vm.posts.length == 0)?_c('div',{staticClass:"empty"},[_vm._v("Your feed is empty.")]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',{staticClass:"post",class:{last: _vm.posts.indexOf(post) === _vm.posts.length - 1}},[_c('div',{staticClass:"photo-container"},[_c('div',{staticClass:"photo",style:(("background: url(" + (post.photoURL) + ")"))})]),_vm._v(" "),_c('div',{staticClass:"underscored"},[_c('span',{staticClass:"text"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(post.name))]),_vm._v(" "+_vm._s(post.text)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",on:{"click":function($event){_vm.removePost(post)}}},[_c('i',{staticClass:"ion-android-close ion"})])])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuItems", function() { return menuItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleWithoutAnimation", function() { return toggleWithoutAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarOpened", function() { return sidebarOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarClicked", function() { return sidebarClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebarHovered", function() { return sidebarHovered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "palette", function() { return palette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoggedIn", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeframe", function() { return timeframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectLoading", function() { return projectLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscription", function() { return subscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterBrandKeys", function() { return filterBrandKeys; });
var menuItems = function menuItems(state) {
  return state.menu.items;
};
var sidebarOpened = function sidebarOpened(state) {
  return state.app.sidebar.opened;
};
var sidebarClicked = function sidebarClicked(state) {
  return state.app.sidebar.clicked;
};
var sidebarHovered = function sidebarHovered(state) {
  return state.app.sidebar.hovered;
};
var toggleWithoutAnimation = function toggleWithoutAnimation(state) {
  return state.app.sidebar.withoutAnimation;
};
var config = function config(state) {
  return state.app.config;
};
var palette = function palette(state) {
  return state.app.config.palette;
};
var isLoading = function isLoading(state) {
  return state.app.isLoading;
};
var isLoggedIn = function isLoggedIn(state) {
  return state.isLoggedIn;
};
var timeframe = function timeframe(state) {
  return state.app.project.timeframe;
};
var projectLoading = function projectLoading(state) {
  return state.app.project.isLoading;
};
var subscription = function subscription(state) {
  return state.app.subscription;
};
var filterBrandKeys = function filterBrandKeys(state) {
  return state.app.project.filterBrandKeys;
};



/***/ }),

/***/ "VAWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__ = __webpack_require__("e8Tw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa98055_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__ = __webpack_require__("uu1+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticPreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa98055_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticPreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VVeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_bulma_expanding_src_Expanding__ = __webpack_require__("OPFe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_scrollbar_VuesticScrollbar__ = __webpack_require__("/7ZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__eventBus_js__ = __webpack_require__("txcq");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_bulma_expanding_src_Expanding__["a" /* default */],
    VuesticScrollbar: __WEBPACK_IMPORTED_MODULE_4__vuestic_components_vuestic_scrollbar_VuesticScrollbar__["default"]
  },
  created: function created() {
    var _this = this;

    this.fetchProjects();
    __WEBPACK_IMPORTED_MODULE_5__eventBus_js__["a" /* EventBus */].$on('fetchItems', function (clickCount) {
      _this.fetchProjects();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    expand: 'toggleExpandMenuItem',
    toggleSidebar: 'hoverSidebar'
  }), {
    computedClass: function computedClass(item) {
      return item.icon || '';
    },
    fetchProjects: function fetchProjects() {
      var _this2 = this;

      this.myMenu = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('projects').then(function (res) {
        if (res.data.length < 1) {
          _this2.myMenu.push({
            name: 'New Project',
            path: '/newproject',
            meta: {
              title: 'New Project',
              iconClass: 'fa fa-plus'
            }
          });
          _this2.$router.push('/newproject');
        } else if (res.data) {
          _this2.myMenu = [];
          res.data.forEach(function (project) {
            var item = {
              name: project.name,
              meta: {
                expanded: false,
                title: project.name,
                projectId: project._id,
                iconClass: 'vuestic-icon vuestic-icon-dashboard',
                url: project.url
              },
              children: [{
                name: 'Dash',
                path: '/project/' + project._id + '/dash',
                meta: {
                  default: false,
                  title: 'Dashboard',
                  url: project.url,
                  icon: 'fa fa-dashboard'
                }
              }, {
                name: 'PageXplorer',
                path: '/project/' + project._id + '/pagexplorer',
                meta: {
                  default: false,
                  title: 'PageXplorer',
                  url: project.url,
                  divider: true,
                  icon: 'fa fa-search'
                }
              }, {
                name: 'KeyXplorer',
                path: '/project/' + project._id + '/keyxplorer',
                meta: {
                  default: false,
                  title: 'KeyXplorer',
                  url: project.url,
                  icon: 'fa fa-search'
                }
              }, {
                name: 'ErrorXplorer',
                path: '/project/' + project._id + '/errors',
                meta: {
                  default: false,
                  title: 'ErrorXplorer',
                  url: project.url,
                  icon: 'fa fa-search'
                }
              }, {
                name: 'PageTracker',
                path: '/project/' + project._id + '/pagetracker',
                meta: {
                  default: false,
                  title: 'PageTracker',
                  url: project.url,
                  divider: true,
                  icon: 'fa fa-line-chart'
                }
              }, {
                name: 'KeyTracker',
                path: '/project/' + project._id + '/keytracker',
                meta: {
                  default: false,
                  title: 'KeyTracker',
                  url: project.url,
                  icon: 'fa fa-line-chart'
                }
              }, {
                name: 'Settings',
                path: '/project/' + project._id + '/settings',
                meta: {
                  default: false,
                  title: 'Settings',
                  divider: true,
                  icon: 'fa fa-cog'
                }
              }]
            };
            _this2.myMenu.push(item);
            if (_this2.$route.path === '/' || _this2.$route.path === '/project') {
              _this2.$router.push('/project/' + _this2.myMenu[0].meta.projectId + '/dash');
            }
          });
          if (JSON.parse(localStorage.getItem('mainuser'))) {
            _this2.myMenu.push({
              name: 'New Project',
              path: '/newproject',
              meta: {
                title: 'New Project',
                iconClass: 'fa fa-plus'
              }
            });
          }
        }
        setTimeout(function () {
          return _this2.toggleMenu(_this2.$route);
        }, 200);
      }).catch(function (e) {
        return console.log(e);
      });
    },
    toggleMenuItem: function toggleMenuItem(item) {
      if (item.children) {
        this.expand({
          menuItem: item,
          expand: !item.meta.expanded
        });
      }
    },
    toggleMenu: function toggleMenu(route) {
      var _this3 = this;

      if (!this.myMenu || !this.sidebarOpened) return;
      var parent = _findMatchingParentMenuItem.call(this, route.name, route.params.id) || {};
      console.log(parent);
      this.myMenu.forEach(function (item) {
        _this3.expand({
          menuItem: item,
          expand: parent.name === item.name
        });
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['sidebarOpened'])),
  watch: {
    $route: function $route(route) {
      this.toggleMenu(route);
    },
    sidebarOpened: function sidebarOpened(newValue) {
      var _this4 = this;

      if (newValue) setTimeout(function () {
        return _this4.toggleMenu(_this4.$route);
      }, 200);
    }
  },
  data: function data() {
    return {
      show: false,
      myMenu: []
    };
  }
});

function _findMatchingParentMenuItem(itemName, projectId) {
  var parentItem = void 0;
  this.myMenu.forEach(function (item) {
    parentItem = item.children && item.children.find(function (child) {
      return child.name === itemName;
    }) && item.meta.projectId === projectId ? item : parentItem;
  });

  return parentItem;
}

/***/ }),

/***/ "WHJM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),

/***/ "WSTi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);




var _mutations;





var state = {
  isLoggedIn: !!localStorage.getItem('token'),
  sidebar: {
    opened: false,
    withoutAnimation: false
  },
  project: {
    timeframe: '28',
    filterBrandKeys: false,
    isLoading: true
  },
  config: {
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#2CE8B5',
      danger: '#F9526E',
      info: '#57B8E5',
      success: '#A88FFF',
      warning: '#FFCF42',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd'
    }
  },
  isLoading: true,
  subscription: function subscription() {
    if (JSON.parse(localStorage.getItem('subscription')) && JSON.parse(localStorage.getItem('subscription')).status === 'active') {
      return true;
    } else {
      return false;
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* CLOSE_MENU */], function (state) {
  if (document.documentElement.clientWidth < 992) {
    state.sidebar.opened = false;
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* TOGGLE_SIDEBAR */], function (state, opened) {
  if (!window.matchMedia(state.config.windowMatchSizeLg).matches) {
    state.sidebar.opened = opened;
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* TOGGLE_SIDEBAR_FORCE */], function (state, opened) {
  state.sidebar.opened = opened;
  state.sidebar.sidebarClicked = opened;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* HOVER_SIDEBAR */], function (state, opened) {
  if (state.sidebar.sidebarClicked) return;
  state.sidebar.sidebarHovered = opened;
  state.sidebar.opened = opened;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* TOGGLE_WITHOUT_ANIMATION */], function (state, value) {
  state.sidebar.withoutAnimation = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* LOGIN */], function (state) {
  state.pending = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* LOGIN_SUCCESS */], function (state) {
  state.isLoggedIn = true;
  state.pending = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* LOGOUT */], function (state) {
  state.isLoggedIn = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SUBSCRIPTION */], function (state, value) {
  state.subscription = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, 'setLoading', function setLoading(state, isLoading) {
  state.isLoading = isLoading;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, 'setTimeframe', function setTimeframe(state, timeframe) {
  state.project.timeframe = timeframe;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, 'setBrandFilter', function setBrandFilter(state, filter) {
  state.project.filterBrandKeys = filter;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, 'setProjectLoading', function setProjectLoading(state, isLoading) {
  state.project.isLoading = isLoading;
}), _mutations);

var actions = {
  closeMenu: function closeMenu(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* CLOSE_MENU */]);
  },
  toggleSidebar: function toggleSidebar(_ref2, opened) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* TOGGLE_SIDEBAR */], opened);
  },
  toggleSidebarClick: function toggleSidebarClick(_ref3, opened) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* TOGGLE_SIDEBAR_FORCE */], opened);
  },
  hoverSidebar: function hoverSidebar(_ref4, opened) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* HOVER_SIDEBAR */], opened);
  },
  isToggleWithoutAnimation: function isToggleWithoutAnimation(_ref5, value) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* TOGGLE_WITHOUT_ANIMATION */], value);
  },
  login: function login(_ref6, token) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* LOGIN */]);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      localStorage.setItem('token', token);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* LOGIN_SUCCESS */]);
      resolve();
    });
  },
  isLoggedIn: function isLoggedIn(_ref7) {
    var commit = _ref7.commit;

    return !!localStorage.getItem('token');
  },
  setSubscription: function setSubscription(_ref8, subscription) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* SUBSCRIPTION */], subscription);
    localStorage.setItem('subscription', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(subscription));
  },
  logout: function logout(_ref9) {
    var _this = this;

    var commit = _ref9.commit;

    console.log('logout');
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('user/logout').then(function (res) {
      console.log(res);
      localStorage.removeItem('token');
      localStorage.removeItem('subscription');
      localStorage.removeItem('mainuser');
      localStorage.removeItem('user');
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* LOGOUT */]);
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ path: '/login' });
    }).catch(function (e) {
      return _this.handleErr(e);
    });
  },
  makeAverage: function makeAverage(_ref10, data) {
    var commit = _ref10.commit;

    var weeklyAvg = 0;
    var weeklyData = [];

    var doLoop = function doLoop(int) {
      for (var i = 0; i < int; i++) {
        weeklyData.push((weeklyAvg / int).toFixed(2));
      }
      weeklyAvg = 0;
    };

    for (var index = 0; index < data.length; index++) {
      var day = data[index];
      weeklyAvg = weeklyAvg + parseFloat(day);
      if ((index + 1) % 7 === 0) doLoop(7);else if (index + 1 === data.length) {
        var remainder = data.length % 7;
        if (remainder > 0) doLoop(remainder);else doLoop(7);
      }
    }

    return {
      backgroundColor: 'transparent',
      borderColor: '#b9b9b9',
      label: 'Avg. Pos',
      yAxisID: 'left-y-axis',
      pointRadius: 0,
      borderWidth: 1,
      steppedLine: true,
      data: weeklyData
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "XG+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'startColor', 'backgroundColor', 'isActive'],
  computed: {
    backgroundImage: function backgroundImage() {
      var result = {};
      if (this.animatedValue < 50) {
        var nextDeg = 90 + 3.6 * this.animatedValue + 'deg';
        result = 'linear-gradient(90deg, ' + this.startColor + ' 50%, transparent 50%, transparent), linear-gradient(' + nextDeg + ', ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      } else {
        var _nextDeg = -90 + 3.6 * (this.animatedValue - 50) + 'deg';
        result = 'linear-gradient(' + _nextDeg + ', ' + this.color + ' 50%, transparent 50%, transparent), linear-gradient(270deg, ' + this.color + ' 50%, ' + this.startColor + ' 50%, ' + this.startColor + ')';
      }
      return result;
    }
  }
});

/***/ }),

/***/ "XbZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){_vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){_vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){_vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XznE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__ = __webpack_require__("KGMZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a02e6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__ = __webpack_require__("UX9s");
function injectStyle (ssrContext) {
  __webpack_require__("kXW0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a02e6ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YKch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-tabs"},[_c('div',{staticClass:"hidden-sm-down"},[_c('nav',{staticClass:"nav nav-pills row"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"nav-item col",class:{active: name === _vm.currentActive},on:{"click":function($event){_vm.setActive(name)}}},[_c('span',{staticClass:"nav-link"},[_c('h5',[_vm._v(_vm._s(name))])])])})),_vm._v(" "),_c('div',{staticClass:"track"},[_c('div',{class:_vm.underscoreClass})])]),_vm._v(" "),_c('vuestic-simple-select',{staticClass:"hidden-md-up simple-select",attrs:{"options":_vm.names},model:{value:(_vm.currentActive),callback:function ($$v) {_vm.currentActive=$$v},expression:"currentActive"}}),_vm._v(" "),_c('div',{staticClass:"tab-content"},_vm._l((_vm.names),function(name){return _c('div',{staticClass:"tab-pane",class:{active: name === _vm.currentActive}},[_vm._t(name)],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__ = __webpack_require__("O3lU");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    name: 'Login',
    path: '/login',
    component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('auth/login/Login'),
    meta: {
      default: false,
      title: 'Login'
    }
  }, {
    name: 'Profile',
    path: '/profile',
    component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('user/Profile'),
    meta: {
      default: false,
      title: 'Profile'
    }
  }, {
    name: 'Subscription',
    path: '/subscription',
    component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('user/Subscription'),
    meta: {
      default: false,
      title: 'Subscription'
    }
  }, {
    name: '',
    path: '/project/:id',

    component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/Project'),
    canReuse: false,
    meta: {
      expanded: false,
      title: '',
      iconClass: 'vuestic-icon vuestic-icon-dashboard'
    },
    children: [{
      name: 'Dash',
      path: 'dash',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/dash/Dash'),
      canReuse: false,
      meta: {
        default: false,
        title: 'Dash'
      }
    }, {
      name: 'PageXplorer',
      path: 'pagexplorer',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/pagexplorer/PageXplorer'),
      canReuse: false,
      meta: {
        default: false,
        title: 'PageXplorer'
      }
    }, {
      name: 'KeyXplorer',
      path: 'keyxplorer',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/keyxplorer/KeyXplorer'),
      meta: {
        default: false,
        title: 'KeyXplorer'
      }
    }, {
      name: 'ErrorXplorer',
      path: 'errors',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/errors/Errors'),
      meta: {
        default: false,
        title: 'ErrorXplorer'
      }
    }, {
      name: 'KeyTracker',
      path: 'keytracker',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/keytracker/KeyTracker'),
      meta: {
        default: false,
        expanded: true,
        title: 'KeyTracker'
      }
    }, {
      name: 'PageTracker',
      path: 'pagetracker',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/pagetracker/PageTracker'),
      meta: {
        default: false,
        title: 'PageTracker'
      }
    }, {
      name: 'Settings',
      path: 'settings',
      component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('project/settings/Settings'),
      meta: {
        default: false,
        title: 'Settings'
      }
    }]
  }, {
    name: 'New Project',
    path: '/newproject',
    component: Object(__WEBPACK_IMPORTED_MODULE_2__store_modules_menu_lazyLoading__["a" /* default */])('newproject/NewProject'),
    meta: {
      default: true,
      title: 'New Project',
      iconClass: 'fa fa-plus'
    }
  }]
}));

/***/ }),

/***/ "YhNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("ZTcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fadfc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("FEme");
function injectStyle (ssrContext) {
  __webpack_require__("4u7H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84fadfc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fadfc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZEli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");




var state = {
  items: []
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* TOGGLE_EXPAND_MENU_ITEM */], function (state, payload) {
  var menuItem = payload.menuItem;
  var expand = payload.expand;
  if (menuItem.children && menuItem.meta) {
    menuItem.meta.expanded = expand;
  }
});

var actions = {
  toggleExpandMenuItem: function toggleExpandMenuItem(_ref, payload) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* TOGGLE_EXPAND_MENU_ITEM */], payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "ZTcl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filterBar',
  data: function data() {
    return {
      filterText: ''
    };
  },

  methods: {
    doFilter: function doFilter() {
      this.$emit('filter', this.filterText);
    }
  }
});

/***/ }),

/***/ "aWV2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aaFx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "anct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__ = __webpack_require__("yuAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3a11024_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__ = __webpack_require__("TkXA");
function injectStyle (ssrContext) {
  __webpack_require__("01TB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSocialNews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3a11024_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSocialNews_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "axM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__ = __webpack_require__("yDzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675c4cbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__ = __webpack_require__("QzAA");
function injectStyle (ssrContext) {
  __webpack_require__("TqWO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_675c4cbf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "b6wd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__ = __webpack_require__("NoHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__ = __webpack_require__("AKm5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__ = __webpack_require__("+S+3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__ = __webpack_require__("+UQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__ = __webpack_require__("q30D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__ = __webpack_require__("eDOj");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chart',
  props: ['data', 'options', 'type'],
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__chart_types_PieChart__["a" /* default */],
    LineChart: __WEBPACK_IMPORTED_MODULE_5__chart_types_LineChart__["a" /* default */],
    VerticalBarChart: __WEBPACK_IMPORTED_MODULE_4__chart_types_VerticalBarChart__["a" /* default */],
    HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_3__chart_types_HorizontalBarChart__["a" /* default */],
    DonutChart: __WEBPACK_IMPORTED_MODULE_2__chart_types_DonutChart__["a" /* default */],
    BubbleChart: __WEBPACK_IMPORTED_MODULE_1__chart_types_BubbleChart__["a" /* default */]
  }
});

/***/ }),

/***/ "b750":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps rich-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('i',{staticClass:"ion ion-android-close step-icon icon-cross"}),_vm._v(" "),_c('i',{staticClass:"ion ion-android-done step-icon icon-check"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-good-pagination',
  props: {
    styleClass: { default: 'table table-bordered' },
    total: { default: null },
    perPage: {},
    rtl: { default: false },

    nextText: { default: 'Next' },
    prevText: { default: 'Prev' },
    rowsPerPageText: { default: 'Rows per page:' },
    ofText: { default: 'of' },
    allText: { default: 'All' }
  },

  data: function data() {
    return {
      currentPage: 1,
      currentPerPage: 10
    };
  },

  methods: {
    nextPage: function nextPage() {
      if (this.currentPerPage === -1) return;
      if (this.nextIsPossible) ++this.currentPage;
      this.pageChanged();
    },
    previousPage: function previousPage() {
      if (this.currentPage > 1) --this.currentPage;
      this.pageChanged();
    },
    pageChanged: function pageChanged() {
      this.$emit('page-changed', { currentPage: this.currentPage });
    },
    perPageChanged: function perPageChanged(event) {
      if (event) {
        this.currentPerPage = parseInt(event.target.value);
      }
      this.$emit('per-page-changed', { currentPerPage: this.currentPerPage });
    }
  },

  watch: {
    perPage: function perPage() {
      if (this.perPage) {
        this.currentPerPage = this.perPage;
      } else {
        this.currentPerPage = 10;
      }
      this.perPageChanged();
    }
  },

  computed: {
    paginatedInfo: function paginatedInfo() {
      if (this.currentPerPage === -1) {
        return '1 - ' + this.total + ' ' + this.ofText + ' ' + this.total;
      }
      var first = (this.currentPage - 1) * this.currentPerPage ? (this.currentPage - 1) * this.currentPerPage : 1;
      var last = Math.min(this.total, this.currentPerPage * this.currentPage);
      return first + ' - ' + last + ' ' + this.ofText + ' ' + this.total;
    },
    nextIsPossible: function nextIsPossible() {
      return this.total > this.currentPerPage * this.currentPage;
    },
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  },

  mounted: function mounted() {
    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }
  }
});

/***/ }),

/***/ "c0ch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  filters: {
    percentage: function percentage(value, decimals) {
      if (!value) value = 0;
      if (!decimals) decimals = 0;

      value = value * 100;
      return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%';
    },
    round: function round(value, decimals) {
      if (!value || typeof value !== 'number') value = 0;
      if (!decimals) decimals = 0;
      return value.toFixed(decimals);
    }
  },
  create: function create(Vue) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter]);
    }.bind(this));
  }
});

/***/ }),

/***/ "cfdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__ = __webpack_require__("y3Nu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddec5616_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__ = __webpack_require__("k+z3");
function injectStyle (ssrContext) {
  __webpack_require__("0xfL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddec5616"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddec5616_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "co6K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"orientation-handler",rawName:"v-orientation-handler",value:({ layout: _vm.wizardLayout,  breakPoint: _vm.orientationBreakPoint }),expression:"{ layout: wizardLayout,  breakPoint: orientationBreakPoint }"}],staticClass:"wizard",class:_vm.computedLayout},[(_vm.computedLayout === 'horizontal')?_c('div',{staticClass:"indicator-container indicator-container-horizontal"},[(_vm.wizardType === 'simple')?_c('simple-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'rich')?_c('rich-horizontal-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.computedLayout === 'vertical')?_c('div',{staticClass:"indicator-container indicator-container-vertical"},[(_vm.wizardType === 'rich')?_c('rich-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e(),_vm._v(" "),(_vm.wizardType === 'simple')?_c('simple-vertical-indicator',{attrs:{"steps":_vm.steps,"currentStep":_vm.currentStep,"completed":_vm.wizardCompleted}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-body"},[_vm._l((_vm.steps),function(step){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStepShown(step)),expression:"isStepShown(step)"}],staticClass:"wizard-body-step"},[_vm._t(step.slot)],2)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.wizardCompleted),expression:"wizardCompleted"}],staticClass:"wizard-body-step"},[_vm._t(_vm.wizardCompletedSlotName)],2),_vm._v(" "),(!_vm.wizardCompleted)?_c('div',{staticClass:"wizard-body-actions"},[(_vm.backEnabled)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-secondary wizard-back pull-left",on:{"click":function($event){_vm.goBack()}}},[_vm._v("\n          Back\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isLastStep())?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right",on:{"click":function($event){_vm.goNext()}}},[_vm._v("\n          Next\n        ")])]):_vm._e(),_vm._v(" "),(_vm.currentStep == _vm.steps.length - 1)?_c('div',{staticClass:"btn-container"},[_c('button',{staticClass:"btn btn-primary wizard-next pull-right final-step",on:{"click":function($event){_vm.completeWizard()}}},[_vm._v("\n          "+_vm._s(_vm.lastStepLabel)+"\n        ")])]):_vm._e()]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dIvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("fom4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d903ef1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__ = __webpack_require__("Bd06");
function injectStyle (ssrContext) {
  __webpack_require__("Oc0A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d903ef1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d903ef1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dRu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-profile-card',
  props: ['photoSource', 'name', 'location', 'social']
});

/***/ }),

/***/ "ddFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ height: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd7e4766_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("ECp3");
function injectStyle (ssrContext) {
  __webpack_require__("2EBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd7e4766"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd7e4766_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dtfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-modal',
  props: {
    transition: {
      type: String,
      default: 'modal'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    force: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String,
      default: 'CONFIRM'
    },
    cancelText: {
      type: String,
      default: 'CANCEL'
    },
    okClass: {
      type: String,
      default: 'btn btn-primary'
    },
    cancelClass: {
      type: String,
      default: 'btn btn-secondary'
    }
  },
  data: function data() {
    return {
      show: false,
      duration: 500
    };
  },

  computed: {
    modalClass: function modalClass() {
      return {
        'modal-lg': this.large,
        'modal-sm': this.small
      };
    }
  },
  created: function created() {
    if (this.show) {
      document.body.className += ' modal-open';
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.body.className = document.body.className.replace(/\s?modal-open/, '');
  },

  watch: {
    show: function show(value) {
      if (value) {
        document.body.className += ' modal-open';
      } else {
        window.setTimeout(function () {
          document.body.className = document.body.className.replace(/\s?modal-open/, '');
        }, this.duration);
      }
    }
  },
  methods: {
    ok: function ok() {
      this.$emit('ok');
      this.show = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.show = false;
    },
    clickMask: function clickMask() {
      if (!this.force) {
        this.cancel();
      }
    },
    open: function open() {
      this.show = true;
    }
  }
});

/***/ }),

/***/ "e8Tw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-pre-loader',
  methods: {
    stop: function stop() {
      this.showSpinner = false;
    }
  },
  mounted: function mounted() {
    this.showSpinner = true;
  },
  data: function data() {
    return {
      mainIndex: 7,
      context: {},
      radius: 4,
      mainRadius: 8,
      interval: {},
      showSpinner: {
        data: Boolean,
        default: false
      }
    };
  }
});

/***/ }),

/***/ "eDOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_annotation__ = __webpack_require__("+WEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_annotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_annotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultOptions__ = __webpack_require__("pzlW");





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Line"].extend({
  props: ['chartData', 'options'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp],
  components: {
    ChartjsPluginAnnotation: __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_annotation___default.a
  },
  watch: {
    'options': {
      handler: function handler(newData, oldData) {
        this.defaultOptions.annotation.annotations = [];
        var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__DefaultOptions__["a" /* default */], this.defaultOptions, newData);
        this.renderChart(this.chartData, options);
      }
    },
    'data': {
      handler: function handler(newData, oldData) {
        var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
        this.renderChart(newData, options);
      }
    }
  },
  data: function data() {
    return {
      defaultOptions: {
        annotation: {
          drawTime: 'beforeDatasetsDraw',
          events: ['mouseover'],
          dblClickSpeed: 350,
          type: 'line',
          annotations: []
        }
      }
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.chartData, options);
  }
}));

/***/ }),

/***/ "ejhQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ewoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group with-icon-right dropdown select-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle",on:{"click":function($event){_vm.$refs.scrollbar.onContainerResize()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayValue),expression:"displayValue"}],class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","name":_vm.name,"required":""},domProps:{"value":(_vm.displayValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.displayValue=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.selectOption(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option))])])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fom4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-rich-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "gvyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-feed',
  props: ['initialPosts'],
  methods: {
    removePost: function removePost(target) {
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var post = _step.value;

          if (post !== target) {
            result.push(post);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.posts = result;
    }
  },
  data: function data() {
    return {
      posts: this.initialPosts
    };
  }
});

/***/ }),

/***/ "i/0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__("MEVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e03894c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__("l+eL");
function injectStyle (ssrContext) {
  __webpack_require__("yUhY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e03894c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iLsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__ = __webpack_require__("GI4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b956e442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__ = __webpack_require__("b750");
function injectStyle (ssrContext) {
  __webpack_require__("nHaI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b956e442"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b956e442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RichVerticalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iQfA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iZBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");




/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    defaultPerPage: {
      type: Number
    }
  },
  data: function data() {
    return {
      selected: this.defaultPerPage
    };
  },

  methods: {
    selectedItemsPerPage: function selectedItemsPerPage(optionValue) {
      this.selected = optionValue;
      this.$emit('items-per-page', this.selected);
    }
  }
});

/***/ }),

/***/ "jEUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("VVeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108c6746_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("RMJU");
function injectStyle (ssrContext) {
  __webpack_require__("K6l1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108c6746_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jW3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("KE38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4f2852be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("BSUt");
function injectStyle (ssrContext) {
  __webpack_require__("aWV2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f2852be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4f2852be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jzLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("lfQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0d745b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__ = __webpack_require__("lBoj");
function injectStyle (ssrContext) {
  __webpack_require__("4jdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b0d745b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0d745b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleHorizontalIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "k+z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(!_vm.hidden)?_c('div',{staticClass:"vuestic-alert alert",class:_vm.alertClass},[_vm._t("default"),_vm._v(" "),(_vm.withCloseBtn)?_c('i',{staticClass:"fa fa-close alert-close",on:{"click":function($event){_vm.hide()}}}):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kT3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "kXW0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("4ik2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: function _default() {
        return null;
      }
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: function _default() {
        return 10;
      }
    },
    initialPage: {
      type: Number,
      default: function _default() {
        return 1;
      }
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      this.apiMode = false;
      if (Array.isArray(data)) {
        this.tableData = data;
        return;
      }

      this.fireEvent('loading');

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        return title + ' ' + this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"');
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAllQueryParams();

      this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};
      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] == 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }

      return result;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      this.loadData();
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        console.log('data mode: array');
        this.setData(this.data);
      } else {
        this.normalizeSortOrder();
        this.setData(this.dataManager(this.sortOrder, this.makePagination()));
      }
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    }
  }
});

/***/ }),

/***/ "l+eL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize"}],class:_vm.classObject},[_c('navbar'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_c('main',{staticClass:"content",attrs:{"id":"content","role":"main"}},[_c('vuestic-pre-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],ref:"preLoader",staticClass:"pre-loader"}),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:_vm.$route.fullPath})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lBoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"wizard-steps horizontal-steps simple-steps",class:{'completed': _vm.completed}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"wizard-step",class:{'active': _vm.currentStep >= index, 'current': _vm.currentStep === index},style:({ width: 100/_vm.steps.length + '%' })},[_c('span',{staticClass:"wizard-step-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-line completed-line"}),_vm._v(" "),_c('span',{staticClass:"wizard-step-label ellipsis"},[_vm._v(_vm._s(step.label))]),_vm._v(" "),_c('span',{staticClass:"wizard-step-indicator"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lYPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-footer clearfix"},[_c('div',{staticClass:"datatable-length pull-left"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.rowsPerPageText))]),_vm._v(" "),_c('select',{staticClass:"browser-default",on:{"change":_vm.perPageChanged}},[(_vm.perPage)?_c('option',{domProps:{"value":_vm.perPage}},[_vm._v(_vm._s(_vm.perPage))]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("20")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"-1"}},[_vm._v(_vm._s(_vm.allText))])])])]),_vm._v(" "),_c('div',{staticClass:"pagination-controls pull-right"},[_c('a',{staticClass:"page-btn",class:{ disabled: !_vm.prevIsPossible },attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.previousPage($event)}}},[_c('span',{staticClass:"chevron",class:{ 'left': !_vm.rtl, 'right': _vm.rtl }}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.prevText))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.paginatedInfo))]),_vm._v(" "),_c('a',{staticClass:"page-btn",class:{ disabled: !_vm.nextIsPossible },attrs:{"href":"javascript:undefined","tabindex":"0"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.nextPage($event)}}},[_c('span',[_vm._v(_vm._s(_vm.nextText))]),_vm._v(" "),_c('span',{staticClass:"chevron",class:{ 'right': !_vm.rtl, 'left': _vm.rtl }})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lfQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard-simple-horizontal-indicator',
  props: {
    steps: {
      type: Array,
      default: []
    },
    currentStep: {
      type: Number,
      default: 0
    },
    completed: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_from":"vue-chartjs@^2.8.1","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"vue-chartjs@^2.8.1","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"^2.8.1","saveSpec":null,"fetchSpec":"^2.8.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","_spec":"vue-chartjs@^2.8.1","_where":"/Users/seb/Code/keylogger","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"bundleDependencies":false,"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"deprecated":false,"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ "lsU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"d-flex flex-md-row flex-column justify-content-md-between align-items-center"},[_c('filter-bar',{on:{"filter":_vm.onFilterSet}}),_vm._v(" "),_c('items-per-page',{attrs:{"options":_vm.itemsPerPage,"defaultPerPage":_vm.perPage},on:{"items-per-page":_vm.onItemsPerPage}})],1),_vm._v(" "),_c('vuetable',{ref:"vuetable",attrs:{"apiUrl":_vm.apiUrl,"apiMode":_vm.apiMode,"fields":_vm.tableFields,"data":_vm.tableData,"dataTotal":_vm.dataCount,"dataManager":_vm.dataManager,"css":_vm.css.table,"dataPath":"data","paginationPath":_vm.paginationPath,"appendParams":_vm.moreParams,"perPage":_vm.perPage},on:{"vuetable:pagination-data":_vm.onPaginationData}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-4"},[_c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"onEachSide":_vm.onEachSide},on:{"vuetable-pagination:change-page":_vm.onChangePage}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mLl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-scrollbar",on:{"transitionend":_vm.onContainerResize}},[_c('div',{ref:"scrollbarWrapper",staticClass:"scrollbar-wrapper"},[_c('div',{ref:"scrollbarContent",staticClass:"scrollbar-content",on:{"wheel":_vm.scroll,"touchstart":_vm.startDrag,"touchmove":_vm.onDrag,"touchend":_vm.stopDrag,"transitionend":_vm.onContentResize}},[_vm._t("default")],2),_vm._v(" "),_c('div',{ref:"track",staticClass:"track"},[_c('div',{ref:"thumb",staticClass:"thumb"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./auth/login/Login.vue": [
		"mEJK",
		10
	],
	"./auth/signup/Signup.vue": [
		"5rG8",
		32
	],
	"./layout/AuthLayout.vue": [
		"v6Pz"
	],
	"./layout/Layout.vue": [
		"i/0a"
	],
	"./layout/navbar/Navbar.vue": [
		"QI9S"
	],
	"./layout/sidebar/Sidebar.vue": [
		"jEUr"
	],
	"./my-components/AnalyticsWidget.vue": [
		"cRq8",
		39
	],
	"./my-components/ColumnChecks.vue": [
		"Cc5i",
		38
	],
	"./my-components/DashWidgets.vue": [
		"iRfb",
		37
	],
	"./my-components/DownloadBtn.vue": [
		"fLso",
		36
	],
	"./my-components/KeywordDash.vue": [
		"JGNJ",
		8
	],
	"./my-components/MultiSelect.vue": [
		"7U9c",
		31
	],
	"./my-components/SimpleSelect.vue": [
		"pUc+",
		30
	],
	"./my-components/SimpleSelectView.vue": [
		"BSLj",
		29
	],
	"./my-components/SmallSpinner.vue": [
		"b5OQ",
		33
	],
	"./my-components/Spinner.vue": [
		"R6a5",
		28
	],
	"./my-components/SpinnerElm.vue": [
		"/PBo",
		27
	],
	"./my-components/TableLegend.vue": [
		"VPPB",
		26
	],
	"./my-components/TimePicker.vue": [
		"9pkO",
		25
	],
	"./my-components/UpdateEditModal.vue": [
		"VEIO",
		34
	],
	"./newproject/NewProject.vue": [
		"j7uU",
		9
	],
	"./project/Project.vue": [
		"GYip",
		7
	],
	"./project/dash/Dash.vue": [
		"blL5",
		4
	],
	"./project/dash/components/PerformerTable.vue": [
		"NV8E",
		24
	],
	"./project/dash/components/TopTable.vue": [
		"gdaF",
		23
	],
	"./project/errors/Errors.vue": [
		"cUcI",
		5
	],
	"./project/errors/components/ErrorModalTable.vue": [
		"NFxX",
		22
	],
	"./project/errors/components/ErrorsTable.vue": [
		"YYE0",
		35
	],
	"./project/keytracker/KeyTracker.vue": [
		"1tlR",
		3
	],
	"./project/keytracker/components/KeytrackerTable.vue": [
		"THcq",
		13
	],
	"./project/keyxplorer/KeyXplorer.vue": [
		"Use7",
		1
	],
	"./project/keyxplorer/components/KeyModalTable.vue": [
		"nF6d",
		19
	],
	"./project/keyxplorer/components/KeywordVuetable.vue": [
		"6XAo",
		18
	],
	"./project/keyxplorer/components/OpportunityTable.vue": [
		"Doyv",
		17
	],
	"./project/pagetracker/PageTracker.vue": [
		"AoSY",
		0
	],
	"./project/pagetracker/components/PageTrackerModalTable.vue": [
		"I1bC",
		16
	],
	"./project/pagetracker/components/PagetrackerTable.vue": [
		"zC1X",
		12
	],
	"./project/pagexplorer/PageXplorer.vue": [
		"26bz",
		2
	],
	"./project/pagexplorer/components/PagesModalTable.vue": [
		"KwUq",
		15
	],
	"./project/pagexplorer/components/PagesVuetable.vue": [
		"pDsM",
		14
	],
	"./project/settings/Settings.vue": [
		"pZHR",
		20
	],
	"./user/Profile.vue": [
		"ylCJ",
		11
	],
	"./user/Subscription.vue": [
		"EGok",
		6
	],
	"./user/components/SubscribeBtn.vue": [
		"Ntya",
		21
	],
	"./vuestic-components/vuestic-alert/VuesticAlert.vue": [
		"cfdX"
	],
	"./vuestic-components/vuestic-chart/VuesticChart.vue": [
		"+Uuv"
	],
	"./vuestic-components/vuestic-chat/VuesticChat.vue": [
		"oXux"
	],
	"./vuestic-components/vuestic-datatable/VuesticDataTable.vue": [
		"tZ2u"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/FilterBar.vue": [
		"YhNO"
	],
	"./vuestic-components/vuestic-datatable/datatable-components/ItemsPerPage.vue": [
		"IbS2"
	],
	"./vuestic-components/vuestic-feed/VuesticFeed.vue": [
		"Q4Rp"
	],
	"./vuestic-components/vuestic-modal/VuesticModal.vue": [
		"NG7M"
	],
	"./vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue": [
		"IqWy"
	],
	"./vuestic-components/vuestic-preloader/VuesticPreLoader.vue": [
		"VAWW"
	],
	"./vuestic-components/vuestic-profile-card/VuesticProfileCard.vue": [
		"74xX"
	],
	"./vuestic-components/vuestic-progress-bar/VuesticProgressBar.vue": [
		"XznE"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/CircleProgressBar.vue": [
		"pqzW"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/HorizontalProgressBar.vue": [
		"CneO"
	],
	"./vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue": [
		"axM2"
	],
	"./vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue": [
		"/7ZL"
	],
	"./vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue": [
		"/LRh"
	],
	"./vuestic-components/vuestic-social-news/VuesticSocialNews.vue": [
		"anct"
	],
	"./vuestic-components/vuestic-switch/VuesticSwitch.vue": [
		"rhzU"
	],
	"./vuestic-components/vuestic-tabs/VuesticTabs.vue": [
		"LtNJ"
	],
	"./vuestic-components/vuestic-widget/VuesticWidget.vue": [
		"Dmbe"
	],
	"./vuestic-components/vuestic-wizard/VuesticWizard.vue": [
		"8/T/"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichHorizontalIndicator.vue": [
		"dIvT"
	],
	"./vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue": [
		"iLsn"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleHorizontalIndicator.vue": [
		"jzLZ"
	],
	"./vuestic-components/vuestic-wizard/indicators/SimpleVerticalIndicator.vue": [
		"0GMg"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "mpwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__ = __webpack_require__("jzLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__ = __webpack_require__("dIvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__ = __webpack_require__("iLsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__ = __webpack_require__("0GMg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__ = __webpack_require__("41de");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-wizard',
  props: {
    steps: {},
    wizardType: {
      type: String,
      default: 'simple'
    },
    wizardLayout: {
      type: String,
      default: 'horizontal'
    },
    lastStepLabel: { default: 'Confirm' },
    onNext: {},
    onBack: {}
  },
  data: function data() {
    return {
      currentStep: 0,
      wizardCompleted: false,
      wizardCompletedSlotName: 'wizardCompleted',
      orientationBreakPoint: 767,
      computedLayout: this.wizardLayout
    };
  },

  components: {
    SimpleHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_0__indicators_SimpleHorizontalIndicator_vue__["default"],
    RichHorizontalIndicator: __WEBPACK_IMPORTED_MODULE_1__indicators_RichHorizontalIndicator_vue__["default"],
    RichVerticalIndicator: __WEBPACK_IMPORTED_MODULE_2__indicators_RichVerticalIndicator_vue__["default"],
    SimpleVerticalIndicator: __WEBPACK_IMPORTED_MODULE_3__indicators_SimpleVerticalIndicator_vue__["default"]
  },
  directives: {
    orientationHandler: __WEBPACK_IMPORTED_MODULE_4__WizardOrientationHandler__["a" /* default */]
  },
  computed: {
    currentSlot: function currentSlot() {
      var slotName = this.steps[this.currentStep].slot;
      if (this.wizardCompleted) {
        slotName = this.wizardCompletedSlotName;
      }
      return slotName;
    },
    backEnabled: function backEnabled() {
      return this.currentStep !== 0;
    }
  },
  created: function created() {
    this.$on('wizardLayoutChange', this.updateLayout);
  },

  methods: {
    updateLayout: function updateLayout(layout) {
      this.computedLayout = layout;
    },
    goNext: function goNext() {
      this.currentStepOnNext();
      if (!this.isLastStep() && this.isCurrentStepValid()) {
        this.currentStep++;
      }
    },
    goBack: function goBack() {
      this.currentStepOnBack();
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    completeWizard: function completeWizard() {
      this.wizardCompleted = true;
      this.goNext();
    },
    isLastStep: function isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    currentStepOnNext: function currentStepOnNext() {
      var step = this.steps[this.currentStep];
      if (step.onNext) {
        step.onNext();
      }
    },
    currentStepOnBack: function currentStepOnBack() {
      var step = this.steps[this.currentStep];
      if (step.onBack) {
        step.onBack();
      }
    },
    isCurrentStepValid: function isCurrentStepValid() {
      return this.steps[this.currentStep].isValid();
    },
    isStepShown: function isStepShown(step) {
      return step.slot === this.currentSlot && !this.wizardCompleted;
    }
  }
});

/***/ }),

/***/ "nHaI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nP/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown.closeOnMenuClick",modifiers:{"closeOnMenuClick":true}}],staticClass:"form-group dropdown"},[_c('button',{staticClass:"btn btn-primary btn-sm dropdown-toggle",attrs:{"id":"itemsPerPageBtn","type":"button","data-toggle":"dropdown"}},[_vm._v("\n    "+_vm._s(_vm.selected)+" per page\n    "),_c('i',{staticClass:"ion-chevron-down arrow-down"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.selectedItemsPerPage(option.value)}}},[_vm._v(_vm._s(option.value)+" per page")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nRnU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "noQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el) {
    var getWindowMatch = function getWindowMatch() {
      return window.matchMedia(__WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.config.windowMatchSizeLg).matches;
    };

    var prevMatchlg = getWindowMatch();

    el.addEventListener('transitionend', function () {
      __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', false);
    });

    window.addEventListener('resize', function () {
      if (getWindowMatch() && !prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', true);
      } else if (!getWindowMatch() && prevMatchlg) {
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('isToggleWithoutAnimation', true);
        __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].dispatch('toggleSidebar', false);
      }
      prevMatchlg = getWindowMatch();
    });
  }
});

/***/ }),

/***/ "nrVG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oK+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_directives_Dropdown__ = __webpack_require__("OR0i");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_6_directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      user: {
        image: 'static/default-user.svg'
      },
      image: 'static/default-user.svg'
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('isLoggedIn').then(function (response) {
                if (response) {
                  try {
                    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('user').then(function (user) {
                      _this.user = user.data;
                      _this.image = _this.user.image || 'static/default-user.svg';

                      localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.user));
                      if (window.$crisp) {
                        window.$crisp.push(['set', 'user:email', _this.user.email]);
                        window.$crisp.push(['set', 'user:nickname', [_this.user.name || _this.user.email]]);
                        if (_this.user.image) {
                          window.$crisp.push(['set', 'user:avatar', [_this.user.image]]);
                        } else {
                          setTimeout(function () {
                            if (window.$crisp) {
                              _this.image = window.$crisp.get('user:avatar') || 'static/default-user.svg';
                            }
                          }, 2000);
                        }
                      }
                    });
                  } catch (e) {
                    console.log(e);
                    _this.show = false;
                    _this.errors.push(e);
                  }
                }
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['sidebarOpened', 'toggleWithoutAnimation', 'isLoggedIn']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['closeMenu', 'toggleSidebar', 'toggleSidebarClick', 'hoverSidebar', 'isToggleWithoutAnimation', 'logout']), {
    moveToProject: function moveToProject() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('projects').then(function (res) {
        if (res.data.length < 1) _this2.$router.push('/newproject');else if (res.data) {
          _this2.$router.push('/project/' + res.data[0]._id + '/dash');
        }
      });
    }
  })
});

/***/ }),

/***/ "oXux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__ = __webpack_require__("zt5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517475ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__ = __webpack_require__("wqQi");
function injectStyle (ssrContext) {
  __webpack_require__("73vl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-517475ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517475ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "otT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__ = __webpack_require__("YhNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__ = __webpack_require__("IbS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_local_data__ = __webpack_require__("zlyx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__ = __webpack_require__("CHUl");










var originalData = __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */].data;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-data-table',
  components: {
    FilterBar: __WEBPACK_IMPORTED_MODULE_2__datatable_components_FilterBar_vue__["default"],
    Vuetable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    ItemsPerPage: __WEBPACK_IMPORTED_MODULE_3__datatable_components_ItemsPerPage_vue__["default"]
  },
  props: {
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      tableData: __WEBPACK_IMPORTED_MODULE_5__data_local_data__["a" /* default */],
      perPage: 6,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: __WEBPACK_IMPORTED_MODULE_6__vuestic_components_vuestic_datatable_data_data_table_styles__["a" /* default */]
    };
  },

  methods: {
    onFilterSet: function onFilterSet(filterText) {
      var _this = this;

      if (this.apiMode) {
        this.moreParams = {
          'filter': filterText
        };
      } else {
        console.log(this.data);
        var txt = new RegExp(filterText, 'i');
        this.tableData.data = originalData.filter(function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
        });
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    },
    onItemsPerPage: function onItemsPerPage(itemsPerPageValue) {
      var _this2 = this;

      this.perPage = itemsPerPageValue;
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.tableData.data;
      var sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function (item1, item2) {
          var sortField = sortOrder[0].sortField;
          var fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === 'desc') {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
});

/***/ }),

/***/ "p1Le":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle progress-bar",style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"overlay",style:('background-color: ' + _vm.backgroundColor + '; color: ' + _vm.color)},[_c('span',[_vm._v(_vm._s(_vm.animatedValue+'%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pNRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dropdown",rawName:"v-dropdown"}],staticClass:"form-group with-icon-right dropdown select-form-group multiselect-form-group",class:{'has-error': _vm.hasErrors()}},[_c('div',{staticClass:"input-group dropdown-toggle",on:{"click":function($event){_vm.$refs.scrollbar.onContainerResize()}}},[_c('input',{class:{'has-value': !!_vm.displayValue},attrs:{"readonly":"","required":""},domProps:{"value":_vm.displayValue}}),_vm._v(" "),_c('i',{staticClass:"ion ion-chevron-down icon-right input-icon"}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]),_c('i',{staticClass:"bar"}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors()),expression:"hasErrors()"}],staticClass:"help text-danger"},[_vm._v(_vm._s(_vm.showRequiredError()))])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenuButton"}},[_c('scrollbar',{ref:"scrollbar"},[_c('div',{staticClass:"dropdown-menu-content"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"dropdown-item",class:{'selected': _vm.isOptionSelected(option)},on:{"click":function($event){_vm.toggleSelection(option)}}},[_c('span',{staticClass:"ellipsis"},[_vm._v(_vm._s(option))]),_vm._v(" "),_c('i',{staticClass:"fa fa-check selected-icon"})])}))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pRV5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-switch"},[_c('div',{staticClass:"vuestic-switch-option true-option",class:{'active': _vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(true)}}},[_vm._t("trueTitle")],2),_vm._v(" "),_c('div',{staticClass:"vuestic-switch-option false-option",class:{'active': !_vm.value},on:{"click":function($event){$event.preventDefault();_vm.setValue(false)}}},[_vm._t("falseTitle")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pqzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__ = __webpack_require__("XG+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0453a1e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__ = __webpack_require__("p1Le");
function injectStyle (ssrContext) {
  __webpack_require__("263+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0453a1e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pr2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "pzlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_store__ = __webpack_require__("IcnI");


var palette = __WEBPACK_IMPORTED_MODULE_0_vuex_store__["a" /* default */].getters.palette;

/* harmony default export */ __webpack_exports__["a"] = ({
  legend: {
    position: 'bottom',
    labels: {
      fontColor: palette.fontColor,
      fontFamily: 'sans-serif',
      fontSize: 14,
      padding: 20,
      usePointStyle: true
    }
  },
  tooltips: {
    bodyFontSize: 14,
    bodyFontFamily: 'sans-serif'
  },
  responsive: true,
  maintainAspectRatio: false
});

/***/ }),

/***/ "q30D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__ = __webpack_require__("pzlW");




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Bar"].extend({
  props: ['data', 'options'],

  data: function data() {
    return {
      defaultOptions: {}
    };
  },
  mounted: function mounted() {
    var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__DefaultOptions__["a" /* default */], this.defaultOptions, this.options);
    this.renderChart(this.data, options);
  }
}));

/***/ }),

/***/ "q8pK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rhzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__ = __webpack_require__("u1r+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098405c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__ = __webpack_require__("pRV5");
function injectStyle (ssrContext) {
  __webpack_require__("aaFx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098405c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sAFs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZ2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__ = __webpack_require__("otT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53863dd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__ = __webpack_require__("lsU8");
function injectStyle (ssrContext) {
  __webpack_require__("LDXv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuesticDataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53863dd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuesticDataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "txcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "u1r+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-switch',
  props: {
    value: Boolean
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  },

  methods: {
    setValue: function setValue(newVal) {
      this.$emit('input', newVal);
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uu1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('div',{staticClass:"parent",class:{ 'active': _vm.showSpinner}},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_vm._v(" "),_c('div',{staticClass:"dot2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v3tk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v6Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("GB0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776097e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("Ah0k");
function injectStyle (ssrContext) {
  __webpack_require__("ejhQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776097e5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vE+0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__ = __webpack_require__("OR0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__ = __webpack_require__("/7ZL");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-simple-select',
  components: {
    Scrollbar: __WEBPACK_IMPORTED_MODULE_1__vuestic_scrollbar_VuesticScrollbar_vue__["default"]
  },
  directives: {
    dropdown: __WEBPACK_IMPORTED_MODULE_0__directives_Dropdown__["a" /* default */]
  },
  data: function data() {
    return {
      displayValue: '',
      validated: false
    };
  },

  props: {
    label: String,
    options: Array,
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'simple-select'
    }
  },
  mounted: function mounted() {
    this.updateDisplayValue(this.value);
    this.$emit('input', this.value);
  },


  updated: function updated() {
    this.updateDisplayValue(this.value);
  },

  methods: {
    isOptionSelected: function isOptionSelected(option) {
      return this.value === option;
    },
    selectOption: function selectOption(option) {
      this.updateDisplayValue(option);
      this.$emit('input', option);
    },
    updateDisplayValue: function updateDisplayValue(val) {
      this.displayValue = val;
    },
    validate: function validate() {
      this.validated = true;
    },
    isValid: function isValid() {
      var isValid = true;
      if (this.required) {
        isValid = !!this.displayValue;
      }
      return isValid;
    },
    hasErrors: function hasErrors() {
      var hasErrors = false;
      if (this.required) {
        hasErrors = this.validated && !this.displayValue;
      }
      return hasErrors;
    },
    showRequiredError: function showRequiredError() {
      return 'The ' + this.name + ' field is required';
    }
  }
});

/***/ }),

/***/ "vuw1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-chat"},[_c('div',{directives:[{name:"sticky-scroll",rawName:"v-sticky-scroll",value:({animate: true, duration: 500}),expression:"{animate: true, duration: 500}"}],staticClass:"chat-body",style:({'height': _vm.height})},_vm._l((_vm.value),function(message){return _c('div',{staticClass:"chat-message",class:{'yours': message.yours, 'alien': !message.yours}},[_vm._v("\n       "+_vm._s(message.text)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"chat-controls"},[_c('fieldset',[_c('div',{staticClass:"form-group form-group-w-btn"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputMessage),expression:"inputMessage"}],attrs:{"required":"","title":""},domProps:{"value":(_vm.inputMessage)},on:{"keypress":function($event){_vm.keyHandler($event)},"input":function($event){if($event.target.composing){ return; }_vm.inputMessage=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Your message")]),_c('i',{staticClass:"bar"})]),_vm._v(" "),_c('div',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.sendMessage()}}},[_vm._v("Send")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wzle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x2GM":
/***/ (function(module, exports, __webpack_require__) {



var browser = __webpack_require__("bJUU");
var erd = __webpack_require__("uk2G")();

var vm = {
  name: 'vuestic-scrollbar',
  props: {
    speed: {
      default: 20
    }
  },
  methods: {
    calcSize: function calcSize() {
      this.isDown = this.isUp = false;
      this.maxHeight = parseFloat(this.wrapper.offsetHeight, 10);
      this.contentHeight = parseFloat(this.content.offsetHeight, 10);
      this.trackHeight = parseFloat(this.track.offsetHeight, 10);
      this.thumb.style.height = this.maxHeight / this.contentHeight * this.trackHeight + 'px';
      if (this.maxHeight / this.contentHeight < 1) {
        this.thumb.classList.add('active');
      } else {
        this.thumb.classList.remove('active');
      }
    },
    calcThumb: function calcThumb() {
      var currentMT = this.content.style.marginTop === '' ? 0 : parseInt(this.content.style.marginTop, 10);
      this.thumb.style.top = -currentMT / this.contentHeight * this.trackHeight + 'px';
    },
    onContainerResize: function onContainerResize() {
      var _this = this;

      erd.listenTo(this.content, function () {
        _this.calcSize();
        _this.calcThumb();
        erd.removeAllListeners(_this.content);
      });
    },
    onContentResize: function onContentResize() {
      var _this2 = this;

      var prevHeight = this.contentHeight;
      this.calcSize();
      this.calcThumb();

      this.content.style.transition = 'margin-top .3s linear';
      this.thumb.style.transition = 'top .3s linear';
      var handler = function handler(e) {
        if (e.propertyName === 'margin-top') {
          _this2.content.style.transition = '';
          _this2.calcSize();
          _this2.calcThumb();
          _this2.content.removeEventListener('transitionend', handler);
          _this2.thumb.style.transition = '';
        }
      };
      this.content.addEventListener('transitionend', handler);

      this.setVertical(this.contentHeight - prevHeight);
    },
    startDrag: function startDrag(e) {
      this.isDragging = true;
      this.prevTouch = e.touches[0];
    },
    onDrag: function onDrag(e) {
      console.log(e);
      if (this.isDragging) {
        e.preventDefault();
        var touch = e.touches[0];
        var delta = this.prevTouch.clientY - touch.clientY;
        this.setVertical(delta);
        this.prevTouch = touch;
      }
    },
    stopDrag: function stopDrag(e) {
      this.isDragging = false;
    },
    scroll: function scroll(e) {
      var delta = e.deltaY * 0.01 * this.speed;
      if (browser.name === 'firefox') {
        delta *= 10;
      }
      this.setVertical(delta);
      e.preventDefault();
    },
    setVertical: function setVertical(delta) {
      if (this.isDown && delta > 0 || this.isUp && delta < 0 || this.contentHeight <= this.maxHeight) {
        return;
      }
      var currentMT = this.content.style.marginTop === '' ? 0 : parseFloat(this.content.style.marginTop, 10);
      var nextMT = 0;
      if (this.maxHeight - (currentMT - delta) > this.contentHeight && delta > 0) {
        nextMT = this.maxHeight - this.contentHeight;
        this.isDown = true;
      } else {
        this.isDown = false;
        if (currentMT - delta > 0) {
          this.isUp = true;
          nextMT = 0;
        } else {
          nextMT = currentMT - delta;
          this.isUp = false;
        }
      }

      if (nextMT < 0) nextMT = 0;
      this.content.style.marginTop = nextMT + 'px';
      this.calcThumb();
    }
  },
  mounted: function mounted() {
    this.track = this.$refs.track;
    this.thumb = this.$refs.thumb;
    this.content = this.$refs.scrollbarContent;
    this.wrapper = this.$refs.scrollbarWrapper;
    this.calcSize();
    this.calcThumb();
  },
  data: function data() {
    return {
      wrapper: undefined,
      maxHeight: undefined,
      thumb: undefined,
      track: undefined,
      trackHeight: undefined,
      content: undefined,
      contentHeight: undefined,
      isDown: false,
      isUp: true,
      prevTouch: {},
      isDragging: false
    };
  }
};

module.exports = vm;

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__ = __webpack_require__("i/0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_AuthLayout__ = __webpack_require__("v6Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__ = __webpack_require__("VAWW");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VuesticPreLoader: __WEBPACK_IMPORTED_MODULE_2__components_vuestic_components_vuestic_preloader_VuesticPreLoader_vue__["default"],
    AuthLayout: __WEBPACK_IMPORTED_MODULE_1__components_layout_AuthLayout__["default"],
    Layout: __WEBPACK_IMPORTED_MODULE_0_components_layout_Layout__["default"]
  },
  computed: {
    isAuth: function isAuth() {
      return this.$route.path.match('login');
    }
  }
});

/***/ }),

/***/ "y3Nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-alert',
  computed: {
    alertClass: function alertClass() {
      return {
        'with-close': this.withCloseBtn,
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info'
      };
    }
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    withCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hidden: false
    };
  },

  methods: {
    hide: function hide() {
      this.hidden = true;
    }
  }
});

/***/ }),

/***/ "yDzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler__ = __webpack_require__("VSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kewler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kewler__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'animatedValue', 'min', 'max', 'color', 'size', 'isActive'],
  mounted: function mounted() {
    var progressBar = this.$refs.progressBar;
    console.log(progressBar.style.transition);
    var progressColor = Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["color"])(this.color);
    var current = progressColor;
    setInterval(function () {
      if (progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30))() !== current()) {
        current = progressColor(Object(__WEBPACK_IMPORTED_MODULE_0_kewler__["lightness"])(30));
      } else {
        current = progressColor;
      }
      progressBar.style.backgroundColor = current();
    }, 500);
  }
});

/***/ }),

/***/ "yUhY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yuAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-social-news',
  props: ['news', 'url']
});

/***/ }),

/***/ "zlyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'pagination': {
    'total': 200,
    'per_page': 50,
    'current_page': 1,
    'last_page': 4,
    'next_page_url': 'https://vuetable.ratiw.net/api/users?per_page=50&page=2',
    'prev_page_url': null,
    'from': 1,
    'to': 50
  },
  'data': [{
    'id': 1,
    'name': 'Noelia O\'Kon',
    'nickname': 'asperiores',
    'email': 'otho.smitham@example.com',
    'birthdate': '1978-06-28 00:00:00',
    'gender': 'F',
    'salary': '13098.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 1,
      'user_id': 1,
      'line1': '0888 Aniyah Locks\nLake Bridie, NJ 51086',
      'line2': 'Cayman Islands',
      'zipcode': '92991-2805',
      'mobile': '1-742-816-9238x848',
      'fax': '(484)438-4697x8638'
    }
  }, {
    'id': 2,
    'name': 'Mr. Enid Von PhD',
    'nickname': 'alias',
    'email': 'pollich.cecilia@example.com',
    'birthdate': '1990-09-18 00:00:00',
    'gender': 'M',
    'salary': '35978.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 2,
      'user_id': 2,
      'line1': '59732 Iva Spur Suite 468\nEast Hortenseton, VA 70087',
      'line2': 'Cayman Islands',
      'zipcode': '41967',
      'mobile': '1-913-407-7558x503',
      'fax': '(388)906-8002'
    }
  }, {
    'id': 3,
    'name': 'Colton Koch',
    'nickname': 'id',
    'email': 'little.myrna@example.net',
    'birthdate': '1968-10-29 00:00:00',
    'gender': 'F',
    'salary': '26278.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 3,
      'user_id': 3,
      'line1': '539 Conn Locks Suite 801\nTobinfort, IL 37047-5508',
      'line2': 'Antigua and Barbuda',
      'zipcode': '51722-4502',
      'mobile': '557.845.1830x844',
      'fax': '1-831-304-7444x73027'
    }
  }, {
    'id': 4,
    'name': 'Gregory Vandervort',
    'nickname': 'vel',
    'email': 'dock47@example.org',
    'birthdate': '1989-12-12 00:00:00',
    'gender': 'M',
    'salary': '25537.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 4,
      'user_id': 4,
      'line1': '916 Rosemary Forge\nKreigerton, MT 24207',
      'line2': 'Uganda',
      'zipcode': '67639-6707',
      'mobile': '766.431.9121',
      'fax': '(154)336-3674x08451'
    }
  }, {
    'id': 5,
    'name': 'Miss Rahsaan Heaney IV',
    'nickname': 'qui',
    'email': 'ugrady@example.org',
    'birthdate': '1995-11-27 00:00:00',
    'gender': 'F',
    'salary': '49003.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 21,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 5,
      'user_id': 5,
      'line1': '91792 Kertzmann Prairie Apt. 376\nLake Nakiaville, DC 98189',
      'line2': 'Jamaica',
      'zipcode': '10101-1450',
      'mobile': '07507519787',
      'fax': '+24(9)5120507985'
    }
  }, {
    'id': 6,
    'name': 'Ms. Crystel Zemlak IV',
    'nickname': 'reiciendis',
    'email': 'amari.rau@example.com',
    'birthdate': '1968-09-12 00:00:00',
    'gender': 'F',
    'salary': '12383.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 6,
      'user_id': 6,
      'line1': '97650 Scot Haven Apt. 160\nCrawfordmouth, ME 39767-7003',
      'line2': 'Finland',
      'zipcode': '88917',
      'mobile': '1-851-069-9234x9566',
      'fax': '(048)445-4691x33356'
    }
  }, {
    'id': 7,
    'name': 'Nona McDermott',
    'nickname': 'quaerat',
    'email': 'adrien.baumbach@example.org',
    'birthdate': '1985-10-01 00:00:00',
    'gender': 'F',
    'salary': '18512.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 31,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 7,
      'user_id': 7,
      'line1': '4332 Alvina Radial\nPort Darbyville, IA 63357',
      'line2': 'Barbados',
      'zipcode': '79679',
      'mobile': '(736)058-1324',
      'fax': '002.234.8466x49816'
    }
  }, {
    'id': 8,
    'name': 'Miss Genoveva Murazik V',
    'nickname': 'rerum',
    'email': 'ohettinger@example.net',
    'birthdate': '1988-10-19 00:00:00',
    'gender': 'F',
    'salary': '31209.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 28,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 8,
      'user_id': 8,
      'line1': '96418 Ritchie Mall Apt. 215\nLake Jessyca, VT 65970-8256',
      'line2': 'Netherlands Antilles',
      'zipcode': '94649-6628',
      'mobile': '472.825.7183',
      'fax': '400-507-7463'
    }
  }, {
    'id': 9,
    'name': 'Beulah Huels',
    'nickname': 'non',
    'email': 'stefan99@example.com',
    'birthdate': '1963-09-04 00:00:00',
    'gender': 'F',
    'salary': '36920.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 9,
      'user_id': 9,
      'line1': '18890 Carroll Lakes Suite 355\nUptonchester, UT 94878-0739',
      'line2': 'Hong Kong',
      'zipcode': '91204',
      'mobile': '831.652.0832',
      'fax': '(688)788-8947'
    }
  }, {
    'id': 10,
    'name': 'Zoe Klein',
    'nickname': 'ex',
    'email': 'ejacobson@example.org',
    'birthdate': '1990-04-19 00:00:00',
    'gender': 'F',
    'salary': '35616.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 10,
      'user_id': 10,
      'line1': '6721 Nader Summit\nLake Alana, MS 84476',
      'line2': 'Reunion',
      'zipcode': '77124-1459',
      'mobile': '1-129-438-6148',
      'fax': '(913)441-3846'
    }
  }, {
    'id': 11,
    'name': 'Vickie Kiehn',
    'nickname': 'assumenda',
    'email': 'ayost@example.com',
    'birthdate': '1988-04-20 00:00:00',
    'gender': 'F',
    'salary': '30790.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 11,
      'user_id': 11,
      'line1': '763 McCullough Ville\nNew Thomasstad, HI 64611',
      'line2': 'Oman',
      'zipcode': '00642',
      'mobile': '1-296-172-2126x275',
      'fax': '(559)203-8694'
    }
  }, {
    'id': 12,
    'name': 'Elwyn Herzog',
    'nickname': 'praesentium',
    'email': 'ckassulke@example.net',
    'birthdate': '1990-01-22 00:00:00',
    'gender': 'M',
    'salary': '35785.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 27,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 12,
      'user_id': 12,
      'line1': '65641 Baron Spurs Suite 988\nNorth Ivah, IA 92235',
      'line2': 'Nepal',
      'zipcode': '90316-7411',
      'mobile': '064.482.9432x9456',
      'fax': '05936098280'
    }
  }, {
    'id': 13,
    'name': 'Selena Hettinger',
    'nickname': 'et',
    'email': 'bashirian.hyman@example.net',
    'birthdate': '1981-10-01 00:00:00',
    'gender': 'F',
    'salary': '31836.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 13,
      'user_id': 13,
      'line1': '42272 Stoltenberg Points Suite 006\nLake Dustin, NH 70213-2043',
      'line2': 'Uganda',
      'zipcode': '60996-2982',
      'mobile': '(508)122-5892',
      'fax': '356-682-2023x07379'
    }
  }, {
    'id': 14,
    'name': 'Edwin Beier',
    'nickname': 'eos',
    'email': 'janis71@example.org',
    'birthdate': '1978-10-13 00:00:00',
    'gender': 'M',
    'salary': '11902.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 14,
      'user_id': 14,
      'line1': '362 Trantow Loop Apt. 150\nLake Marafurt, DC 27926',
      'line2': 'Gabon',
      'zipcode': '36943-1099',
      'mobile': '033-386-4972x26066',
      'fax': '1-363-037-1381'
    }
  }, {
    'id': 15,
    'name': 'Lexi Braun MD',
    'nickname': 'autem',
    'email': 'dusty74@example.net',
    'birthdate': '1971-12-07 00:00:00',
    'gender': 'F',
    'salary': '11927.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 45,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 15,
      'user_id': 15,
      'line1': '6737 Schimmel Crossing Suite 720\nShieldsberg, AK 44558',
      'line2': 'Tanzania',
      'zipcode': '75615',
      'mobile': '338.920.3112',
      'fax': '(467)912-6668'
    }
  }, {
    'id': 16,
    'name': 'Jovany Spencer',
    'nickname': 'fugit',
    'email': 'gbogisich@example.org',
    'birthdate': '1974-04-23 00:00:00',
    'gender': 'F',
    'salary': '44686.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 16,
      'user_id': 16,
      'line1': '97237 Emory Mission\nWelchview, DE 65827-8746',
      'line2': 'Turkmenistan',
      'zipcode': '17948',
      'mobile': '(163)991-1609x963',
      'fax': '104.893.7648'
    }
  }, {
    'id': 17,
    'name': 'Prof. Maci Anderson DVM',
    'nickname': 'dolorem',
    'email': 'btorp@example.com',
    'birthdate': '1988-03-30 00:00:00',
    'gender': 'M',
    'salary': '25055.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 29,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 17,
      'user_id': 17,
      'line1': '7584 Lucinda Mill\nNew Kaitlyn, WV 63380-4289',
      'line2': 'Gibraltar',
      'zipcode': '51150-2800',
      'mobile': '(977)115-7349',
      'fax': '652-788-4860x1180'
    }
  }, {
    'id': 18,
    'name': 'Joel Kulas MD',
    'nickname': 'sed',
    'email': 'phoebe.sauer@example.org',
    'birthdate': '1992-10-26 00:00:00',
    'gender': 'F',
    'salary': '11650.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 18,
      'user_id': 18,
      'line1': '992 Williamson Passage Apt. 910\nBradleyborough, MO 93100-9439',
      'line2': 'Cambodia',
      'zipcode': '20591-3066',
      'mobile': '+64(7)3402369877',
      'fax': '08960801902'
    }
  }, {
    'id': 19,
    'name': 'Mr. Dawson Greenholt',
    'nickname': 'nostrum',
    'email': 'asawayn@example.org',
    'birthdate': '1963-08-23 00:00:00',
    'gender': 'F',
    'salary': '46962.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 19,
      'user_id': 19,
      'line1': '8444 Abraham Isle\nEast Chaunceychester, HI 78625-4417',
      'line2': 'Qatar',
      'zipcode': '47870-8012',
      'mobile': '797-274-3187x45557',
      'fax': '(461)432-8205'
    }
  }, {
    'id': 20,
    'name': 'Prof. Lloyd Green',
    'nickname': 'velit',
    'email': 'laila.hintz@example.org',
    'birthdate': '1970-10-31 00:00:00',
    'gender': 'M',
    'salary': '12928.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 20,
      'user_id': 20,
      'line1': '89766 O\'Connell Falls\nSouth Kadenshire, NJ 78754-6650',
      'line2': 'Nigeria',
      'zipcode': '37859',
      'mobile': '1-457-536-1138',
      'fax': '+98(5)0101745942'
    }
  }, {
    'id': 21,
    'name': 'Shayna Morar',
    'nickname': 'rerum',
    'email': 'wfay@example.org',
    'birthdate': '1991-01-24 00:00:00',
    'gender': 'F',
    'salary': '22638.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 26,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 21,
      'user_id': 21,
      'line1': '6066 Weissnat Run Apt. 578\nMurazikmouth, SD 62877-3174',
      'line2': 'Brunei Darussalam',
      'zipcode': '69261',
      'mobile': '(487)423-0151x5127',
      'fax': '784-058-9197'
    }
  }, {
    'id': 22,
    'name': 'Krista Schulist',
    'nickname': 'qui',
    'email': 'gregoria.jakubowski@example.com',
    'birthdate': '1974-08-16 00:00:00',
    'gender': 'F',
    'salary': '49345.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 22,
      'user_id': 22,
      'line1': '331 Gerlach Course Suite 090\nKovacekchester, RI 18017',
      'line2': 'Sri Lanka',
      'zipcode': '37165',
      'mobile': '653-487-3061x91119',
      'fax': '370-709-1750'
    }
  }, {
    'id': 23,
    'name': 'Leone Lemke',
    'nickname': 'repellat',
    'email': 'ltorphy@example.com',
    'birthdate': '1975-06-27 00:00:00',
    'gender': 'M',
    'salary': '17560.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 23,
      'user_id': 23,
      'line1': '4371 Ward Village Suite 848\nLake Madalynton, IN 44643',
      'line2': 'Ukraine',
      'zipcode': '71848',
      'mobile': '174-502-0881x50649',
      'fax': '02683328099'
    }
  }, {
    'id': 24,
    'name': 'Dr. Willie Kemmer II',
    'nickname': 'quasi',
    'email': 'ivy51@example.net',
    'birthdate': '1987-04-06 00:00:00',
    'gender': 'F',
    'salary': '35370.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 30,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 24,
      'user_id': 24,
      'line1': '235 Hassie Mountain\nAnikaborough, ID 20678-4354',
      'line2': 'Thailand',
      'zipcode': '94264-9132',
      'mobile': '624.042.8382x12243',
      'fax': '274.716.7226x171'
    }
  }, {
    'id': 25,
    'name': 'Deonte Lebsack',
    'nickname': 'nesciunt',
    'email': 'alisa83@example.net',
    'birthdate': '1993-01-26 00:00:00',
    'gender': 'M',
    'salary': '32725.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 25,
      'user_id': 25,
      'line1': '793 Lakin Haven\nLake Citlalliborough, DE 85031-4862',
      'line2': 'Chad',
      'zipcode': '52396-8822',
      'mobile': '(950)170-8013',
      'fax': '119.675.5485x79062'
    }
  }, {
    'id': 26,
    'name': 'Prof. Shayne Nader',
    'nickname': 'voluptas',
    'email': 'bosco.shaina@example.net',
    'birthdate': '1993-10-26 00:00:00',
    'gender': 'F',
    'salary': '9844.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 23,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 26,
      'user_id': 26,
      'line1': '0330 Smith Mountains\nLorinetown, NY 96547-9723',
      'line2': 'Syrian Arab Republic',
      'zipcode': '85415',
      'mobile': '1-212-704-6685',
      'fax': '516-893-8515'
    }
  }, {
    'id': 27,
    'name': 'Prof. Kennith Kertzmann',
    'nickname': 'alias',
    'email': 'satterfield.jonathan@example.com',
    'birthdate': '1992-01-31 00:00:00',
    'gender': 'F',
    'salary': '41950.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 27,
      'user_id': 27,
      'line1': '901 Hauck Extensions\nKeaganborough, VA 47392',
      'line2': 'Comoros',
      'zipcode': '54147-7615',
      'mobile': '1-274-179-2031x915',
      'fax': '867-583-0812x6728'
    }
  }, {
    'id': 28,
    'name': 'Miss Meagan O\'Keefe',
    'nickname': 'corporis',
    'email': 'tracy.barrows@example.com',
    'birthdate': '1967-05-04 00:00:00',
    'gender': 'M',
    'salary': '41803.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 28,
      'user_id': 28,
      'line1': '29077 Avis Isle Apt. 208\nGrahamberg, MI 62485-6694',
      'line2': 'Cocos (Keeling) Islands',
      'zipcode': '56090-7671',
      'mobile': '(718)856-9319x55184',
      'fax': '(777)055-4685x56167'
    }
  }, {
    'id': 29,
    'name': 'Prof. Edward Pagac MD',
    'nickname': 'quia',
    'email': 'gerhard65@example.org',
    'birthdate': '1973-09-22 00:00:00',
    'gender': 'F',
    'salary': '22896.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 43,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 29,
      'user_id': 29,
      'line1': '697 Crona Mall\nPeteville, WA 54497',
      'line2': 'Saudi Arabia',
      'zipcode': '07560-8569',
      'mobile': '788-579-8208',
      'fax': '041-521-9215'
    }
  }, {
    'id': 30,
    'name': 'Samantha Weissnat',
    'nickname': 'est',
    'email': 'crystel66@example.net',
    'birthdate': '1974-07-11 00:00:00',
    'gender': 'M',
    'salary': '18805.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 30,
      'user_id': 30,
      'line1': '79984 Deckow Run\nEast Victoria, UT 33736',
      'line2': 'Lithuania',
      'zipcode': '95964-8864',
      'mobile': '681.200.3099',
      'fax': '(567)652-4322x61475'
    }
  }, {
    'id': 31,
    'name': 'Dr. Gilbert Ward',
    'nickname': 'dolorum',
    'email': 'sandrine06@example.net',
    'birthdate': '1984-08-22 00:00:00',
    'gender': 'F',
    'salary': '16644.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 32,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 31,
      'user_id': 31,
      'line1': '996 Schuppe Glen\nTurcottetown, ID 40821-7190',
      'line2': 'Thailand',
      'zipcode': '09965-7576',
      'mobile': '1-938-263-0257x47178',
      'fax': '1-997-727-3198x4363'
    }
  }, {
    'id': 32,
    'name': 'Mike West',
    'nickname': 'laudantium',
    'email': 'jborer@example.net',
    'birthdate': '1974-11-07 00:00:00',
    'gender': 'M',
    'salary': '35728.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 32,
      'user_id': 32,
      'line1': '69942 Leannon Glen\nEast Mathilde, IL 89584-5633',
      'line2': 'Afghanistan',
      'zipcode': '02041-8706',
      'mobile': '(506)349-9443x7244',
      'fax': '1-357-689-8479x3729'
    }
  }, {
    'id': 33,
    'name': 'Prof. Isabell Cruickshank I',
    'nickname': 'recusandae',
    'email': 'ondricka.lurline@example.org',
    'birthdate': '1982-06-15 00:00:00',
    'gender': 'F',
    'salary': '44574.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 33,
      'user_id': 33,
      'line1': '875 Logan Summit Suite 033\nJerodport, NY 45166',
      'line2': 'Kiribati',
      'zipcode': '64763',
      'mobile': '1-548-943-8405x460',
      'fax': '+88(4)9493664736'
    }
  }, {
    'id': 34,
    'name': 'Prof. Lonny Rath',
    'nickname': 'nihil',
    'email': 'rfeest@example.net',
    'birthdate': '1969-04-23 00:00:00',
    'gender': 'F',
    'salary': '19949.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 48,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 34,
      'user_id': 34,
      'line1': '43006 Gaylord Drives\nCummerataville, MA 14032-6378',
      'line2': 'Georgia',
      'zipcode': '88459',
      'mobile': '(877)526-6771',
      'fax': '(724)630-5418'
    }
  }, {
    'id': 35,
    'name': 'Santina Medhurst MD',
    'nickname': 'suscipit',
    'email': 'ila24@example.net',
    'birthdate': '1965-11-04 00:00:00',
    'gender': 'F',
    'salary': '36323.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 51,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 35,
      'user_id': 35,
      'line1': '47345 Imelda Mission Suite 257\nAllyshire, IA 85430-2783',
      'line2': 'Gambia',
      'zipcode': '26853',
      'mobile': '(441)229-8922',
      'fax': '(789)908-0620x15912'
    }
  }, {
    'id': 36,
    'name': 'Jeff Lehner',
    'nickname': 'quo',
    'email': 'jarred77@example.com',
    'birthdate': '1975-05-18 00:00:00',
    'gender': 'F',
    'salary': '48462.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 36,
      'user_id': 36,
      'line1': '49133 Tremaine Cape Suite 189\nQuitzonview, SC 07967-6920',
      'line2': 'Serbia',
      'zipcode': '96642',
      'mobile': '313.254.8635x06428',
      'fax': '194.681.7297x74202'
    }
  }, {
    'id': 37,
    'name': 'Samanta Pfeffer',
    'nickname': 'officia',
    'email': 'fgoyette@example.net',
    'birthdate': '1974-08-27 00:00:00',
    'gender': 'F',
    'salary': '19601.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 42,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 37,
      'user_id': 37,
      'line1': '1313 Verdie Square\nNorth Giovanna, MI 27962',
      'line2': 'Guyana',
      'zipcode': '77776',
      'mobile': '(321)705-8910',
      'fax': '(392)460-5663x665'
    }
  }, {
    'id': 38,
    'name': 'Ofelia Torp',
    'nickname': 'a',
    'email': 'ericka44@example.net',
    'birthdate': '1981-09-01 00:00:00',
    'gender': 'M',
    'salary': '33149.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 35,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 38,
      'user_id': 38,
      'line1': '45335 Albina View\nCharlottefort, AK 57789',
      'line2': 'Afghanistan',
      'zipcode': '54947-9310',
      'mobile': '09097085723',
      'fax': '1-567-446-3094'
    }
  }, {
    'id': 39,
    'name': 'Mrs. Margarete Raynor',
    'nickname': 'quia',
    'email': 'jlegros@example.net',
    'birthdate': '1977-03-12 00:00:00',
    'gender': 'M',
    'salary': '21951.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 40,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 39,
      'user_id': 39,
      'line1': '288 Hamill Knolls\nMaximoburgh, NC 50971',
      'line2': 'Zimbabwe',
      'zipcode': '00474',
      'mobile': '1-165-445-8956x699',
      'fax': '164-395-7526x1304'
    }
  }, {
    'id': 40,
    'name': 'Mr. Brant Howell V',
    'nickname': 'perspiciatis',
    'email': 'franecki.gerald@example.org',
    'birthdate': '1964-03-01 00:00:00',
    'gender': 'M',
    'salary': '41552.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 53,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 40,
      'user_id': 40,
      'line1': '3411 Deckow Crossing\nVernonport, MI 32272-8542',
      'line2': 'Bolivia',
      'zipcode': '00960',
      'mobile': '(998)729-9537',
      'fax': '(606)461-9736'
    }
  }, {
    'id': 41,
    'name': 'Reilly Ruecker DVM',
    'nickname': 'ad',
    'email': 'ldeckow@example.net',
    'birthdate': '1975-07-17 00:00:00',
    'gender': 'M',
    'salary': '22709.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 41,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 41,
      'user_id': 41,
      'line1': '39181 Runolfsson Pines Apt. 102\nCedrickchester, MD 73430-4755',
      'line2': 'Haiti',
      'zipcode': '08208-7956',
      'mobile': '625-483-9111x773',
      'fax': '196-367-9338'
    }
  }, {
    'id': 42,
    'name': 'Zachery McDermott',
    'nickname': 'molestiae',
    'email': 'gladyce84@example.com',
    'birthdate': '1992-04-17 00:00:00',
    'gender': 'F',
    'salary': '32354.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 25,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 42,
      'user_id': 42,
      'line1': '18735 Quigley Springs\nCarterview, NE 29126-7625',
      'line2': 'Chad',
      'zipcode': '61676-5075',
      'mobile': '172.676.4844x42744',
      'fax': '129.383.7365x233'
    }
  }, {
    'id': 43,
    'name': 'Heloise Kulas',
    'nickname': 'aut',
    'email': 'kessler.helen@example.net',
    'birthdate': '1962-12-11 00:00:00',
    'gender': 'M',
    'salary': '45086.00',
    'group_id': 5,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 54,
    'group': {
      'id': 5,
      'name': 'Emp',
      'description': 'Employees'
    },
    'address': {
      'id': 43,
      'user_id': 43,
      'line1': '38208 Dolores Turnpike Apt. 887\nWintheiserton, FL 72054-2578',
      'line2': 'Lithuania',
      'zipcode': '51634-6449',
      'mobile': '1-161-626-3235x57765',
      'fax': '360-278-9045x9316'
    }
  }, {
    'id': 44,
    'name': 'Norma Dibbert',
    'nickname': 'amet',
    'email': 'eudora36@example.net',
    'birthdate': '1971-01-21 00:00:00',
    'gender': 'F',
    'salary': '15661.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 46,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 44,
      'user_id': 44,
      'line1': '15405 Haag Haven Suite 047\nBrakusland, WV 81778',
      'line2': 'British Virgin Islands',
      'zipcode': '56087-0885',
      'mobile': '08227730599',
      'fax': '1-079-566-2337x670'
    }
  }, {
    'id': 45,
    'name': 'Immanuel Auer',
    'nickname': 'quia',
    'email': 'halvorson.theodora@example.org',
    'birthdate': '1978-06-06 00:00:00',
    'gender': 'M',
    'salary': '15862.00',
    'group_id': 3,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 3,
      'name': 'Mgr',
      'description': 'Managers'
    },
    'address': {
      'id': 45,
      'user_id': 45,
      'line1': '59888 Dare Ridge\nSouth Annamaeton, CA 94659',
      'line2': 'Mexico',
      'zipcode': '56689-3824',
      'mobile': '523.579.8757x9825',
      'fax': '688.695.5156x073'
    }
  }, {
    'id': 46,
    'name': 'Lamont Borer',
    'nickname': 'expedita',
    'email': 'trantow.neoma@example.com',
    'birthdate': '1992-06-26 00:00:00',
    'gender': 'M',
    'salary': '12544.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 24,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 46,
      'user_id': 46,
      'line1': '974 Brannon Circle Suite 674\nSchroedermouth, NM 66911',
      'line2': 'Malawi',
      'zipcode': '74027',
      'mobile': '887.196.2530x875',
      'fax': '220.398.6969'
    }
  }, {
    'id': 47,
    'name': 'Brooke Purdy',
    'nickname': 'cupiditate',
    'email': 'bhermiston@example.net',
    'birthdate': '1966-11-19 00:00:00',
    'gender': 'M',
    'salary': '14457.00',
    'group_id': 4,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 50,
    'group': {
      'id': 4,
      'name': 'Sup',
      'description': 'Supervisors'
    },
    'address': {
      'id': 47,
      'user_id': 47,
      'line1': '916 Durgan Harbor\nWest Tonyborough, MN 08368',
      'line2': 'Serbia',
      'zipcode': '25234',
      'mobile': '(821)777-8137x4048',
      'fax': '(398)917-7496x84537'
    }
  }, {
    'id': 48,
    'name': 'Dr. Leo Dach',
    'nickname': 'et',
    'email': 'camila.ward@example.com',
    'birthdate': '1968-01-11 00:00:00',
    'gender': 'F',
    'salary': '40278.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 49,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 48,
      'user_id': 48,
      'line1': '434 Dariana Terrace\nSouth Brettbury, NC 66080-2445',
      'line2': 'Latvia',
      'zipcode': '81749-2523',
      'mobile': '1-988-628-9566x4627',
      'fax': '916.932.2071x569'
    }
  }, {
    'id': 49,
    'name': 'Krystal Langosh',
    'nickname': 'voluptatum',
    'email': 'pacocha.yesenia@example.org',
    'birthdate': '1983-02-18 00:00:00',
    'gender': 'M',
    'salary': '9305.00',
    'group_id': 2,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 34,
    'group': {
      'id': 2,
      'name': 'Exec',
      'description': 'Executives'
    },
    'address': {
      'id': 49,
      'user_id': 49,
      'line1': '012 Josiane Flats Suite 650\nKatelynntown, MD 70053',
      'line2': 'Rwanda',
      'zipcode': '75946-8166',
      'mobile': '(556)620-0323x81232',
      'fax': '1-466-040-3197x6274'
    }
  }, {
    'id': 50,
    'name': 'Florence Greenfelder',
    'nickname': 'odit',
    'email': 'kenyatta.oconnell@example.com',
    'birthdate': '1978-08-20 00:00:00',
    'gender': 'F',
    'salary': '36980.00',
    'group_id': 1,
    'created_at': '2017-01-01 07:21:10',
    'updated_at': '2017-01-01 07:21:10',
    'age': 38,
    'group': {
      'id': 1,
      'name': 'Admin',
      'description': 'Administrators'
    },
    'address': {
      'id': 50,
      'user_id': 50,
      'line1': '295 Donna Plaza Apt. 186\nHintzview, GA 44706',
      'line2': 'Greenland',
      'zipcode': '03127',
      'mobile': '1-044-098-3635x9446',
      'fax': '1-753-472-6796'
    }
  }]
});

/***/ }),

/***/ "zt5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_StickyScroll__ = __webpack_require__("NS1P");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuestic-chat',
  directives: { StickyScroll: __WEBPACK_IMPORTED_MODULE_0__directives_StickyScroll__["a" /* default */] },
  props: {
    value: {
      type: Array,
      default: []
    },
    height: {
      default: '20rem'
    }
  },
  data: function data() {
    return {
      inputMessage: ''
    };
  },

  methods: {
    keyHandler: function keyHandler(event) {
      if (event.keyCode === 13) {
        this.sendMessage();
      }
    },
    sendMessage: function sendMessage() {
      if (this.inputMessage) {
        this.$emit('input', this.value.concat({
          text: this.inputMessage,
          yours: true
        }));
        this.inputMessage = '';
      }
    }
  },
  mounted: function mounted() {
    this.$emit('input', this.value);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b6369f58fb009b7e0ddb.js